import * as ResponsiveFns from './ResponsiveFns';
import * as StyleFunctions from './StyleFunctions';
import * as CoreFns from './CoreFns';
import * as RichTextPiece from '../ContentItems/RichTextPiece';
import * as EditorHelpers from './EditorHelpers';
import * as ActionModifiers from '../ActionModifiers';
import * as DimensionsFns from './DimensionsFns';

export function getOrig(currentList, whatDrop, objPath){
  var obj = CoreFns.goDownPath(currentList, objPath);
  if (obj){
    var objStyle = obj.s;
    if (objStyle){
      if (objStyle[whatDrop]){
        return objStyle[whatDrop].v;
      }
    }

  }
  return '';    
}

function getOrigNoV(currentList, whatDrop, objPath){
  var obj = CoreFns.goDownPath(currentList, objPath);
  if (obj){
    var objStyle = obj.s;
    if (objStyle){
      return objStyle[whatDrop];
    }
  }
  return '';    
}




export function isNavPath(objPath){
  if (objPath[2] === 'nv'){
    return true;
  }
  return false;
}

function doBoolean(n, i, h){
  return {t:'form', n,i, h, f:0, fo:{t:'Boolean', v:1}}
}

function doBooleanReverse(n, i, h){
  return {t:'form', n,i, h, f:0, fo:{t:'Boolean', v:2}}
}

function doBooleanWithFormula(n, i, h){
  return {t:'form', n,i, h, f:1, fo:{t:'Boolean', v:1}}
}


function addBIUSet(thingsToChange){
    thingsToChange.push(doBooleanWithFormula('Bold', 'B', ''));
    thingsToChange.push(doBooleanWithFormula('Italics', 'I', ''));
    thingsToChange.push(doBoolean('Underline','U',''));
    thingsToChange.push({t:'distance',i:'fontSize',f:{t:'Font Size'}});  
}

export function doASetOfUploadOrDownloadTemplateModifiers(thisItem1, itemType, itemPath, doWhat, currentList, chains, changeTab){
    var warningsHere = [];
    var info = {startItemPath:itemPath};
    if (itemType === 'ALERT'){
      warningsHere = ActionModifiers.goThroughAnItem(itemPath, thisItem1, 'alert', doWhat, info, currentList, chains, changeTab);
    }else if (itemType === 'navBar'){
      warningsHere = ActionModifiers.doANavBar(itemPath, thisItem1, doWhat, info, currentList, chains, changeTab);

    }else if (itemType === 'FOOTER'){
      warningsHere = ActionModifiers.doFooter(itemPath, thisItem1, doWhat, info, currentList, chains, changeTab);
    }else if (itemType === 'PANEL'){
      warningsHere = ActionModifiers.doAPanel(itemPath, thisItem1, doWhat, info, currentList, chains, changeTab);
    }else if (itemType === 'fe' || itemType === 'pu'){
      warningsHere = ActionModifiers.doAPage(itemPath, thisItem1, doWhat, info, currentList, chains, changeTab);
    }else{
      warningsHere = ActionModifiers.goThroughAnItem(itemPath, thisItem1, 'item', doWhat, info, currentList, chains, changeTab);
    }
    return warningsHere;
}

export  function getPosition(orderedKeys, thisP){
  for (var i5 = 0; i5 < orderedKeys.length; i5++ ){
    if (orderedKeys[i5] === thisP){
      return +i5;
    }
  }
  return -1;
}

export function directoryOfThingsToChange(chains, changeTab, isShowingSomeDropDown, currentList, objPath, insetWidth, insetHeight, organicChanges, isClickingOnContentDiv, logInState, sessionID, signKey, userID, userNos, setItemEdited, setIsShowingSomeDropDown, screenRefs){
  var t  = isShowingSomeDropDown.t;
  var thingsToChange = [];
  var thisItem = CoreFns.goDownPath(currentList, objPath);

  var isNavItself = false;
  if (objPath[2] === 'nv'){
    if (objPath.length === 3){
      isNavItself = true;
      if (objPath[0] === 'cn'){
      }else{
        var navPoint = CoreFns.goDownPath(currentList, objPath).on;
        if (navPoint === 1){
        }else{
          objPath = ['cn', navPoint, 'nv'];
          thisItem = CoreFns.goDownPath(currentList, objPath);
        }
      }
    }
  }


  function additionalsForAdmin(thingsToChangeX, itemTitle){
      // thingsToChangeX.push(doListText(itemTitle + ' tags', 'replTag', '[Admin Function] This tags the '+itemTitle+' so that its styles can be swapped out.'));
    // var title = 'Upload ' + itemTitle + ' as Template';
    // thingsToChangeX.push({t:'form', n:title, fo:{t:'Execute', ic:'mdi:rocket-launch-outline', f:submitItemTemplate(itemType)}});
}
  
  function executeCombineFn(parentalPath, aScreenKey, toC, index, itemType){

    return function(e){
      var screens = CoreFns.goDownPath(currentList, parentalPath);
      var screenKeys = CoreFns.sortedKeyList(screens);
      var thisItem = screens[aScreenKey];
      var secondKey = screenKeys[index - 1];

      var addChanges =  doAddChanges(currentList, parentalPath.concat([aScreenKey]), parentalPath.concat([secondKey]), chains, changeTab);
      toC.forEach((aC, index)=>{


        var previousNextOrd = 0;
        if (aC.checkOrd){
          var pathToCheck = parentalPath.concat([secondKey, aC.t]);
          previousNextOrd = ResponsiveFns.getNextOrd(currentList, pathToCheck);
        }


        var elementsToShift = thisItem[aC.t];
        var elementsToShiftKeys = Object.keys(elementsToShift);
        elementsToShiftKeys.forEach((anElementKey, index)=>{
          var thisEle = elementsToShift[anElementKey];
          if (aC.checkOrd){
            thisEle.s.ord.v = thisEle.s.ord.v + previousNextOrd;
          }
          addChanges.push({t:'w',w:pathToCheck.concat([anElementKey]), n:thisEle});
        })

      })

      addChanges.push({t:'r',w:parentalPath,i:aScreenKey});
      organicChanges(addChanges);
      setItemEdited({t:itemType, path:parentalPath.concat([secondKey])})

    }
  }



  if (t === 'itemPosition'){
    var setOfContainersPath = CoreFns.filterPathStopBefore(objPath, objPath.length - 1);
    var parents = CoreFns.goDownPath(currentList, setOfContainersPath);
    var thisP =  objPath[objPath.length - 1];
    var orderedKeys = ResponsiveFns.sortAListBasedOnOrd(parents);
    var ind = getPosition(orderedKeys, thisP);

    thingsToChange.push({t:'instructions', n:'You can drag this item (via its yellow border) to drop it into a different position. These positions are indicated with a "Drop ___ here" text when you start dragging.'});      

    function shiftX(replaceWith){

      return function(e){
        var firstKey = orderedKeys[ind];
        var secondKey = orderedKeys[ind + replaceWith];
        var firstOrd = parents[firstKey].s.ord.v;
        var secondOrd = parents[secondKey].s.ord.v;
        var changes = [{t:'w',w: setOfContainersPath.concat([firstKey, 's', 'ord', 'v']), n:secondOrd}, {t:'w',w: setOfContainersPath.concat([secondKey, 's', 'ord', 'v']), n:firstOrd}];

        organicChanges(changes);
      }
    }

    var txt = 'Up';
    var lText = 'up';
    var txt1 = 'Down';
    var ltxt1 = 'down';

    var isNavItem = isNavPath(objPath);

    if (StyleFunctions.isFirstLevel(objPath) || isNavItem){
    }else{
      var parentItem = CoreFns.goDownPath(currentList, objPath, 2);
      if (parentItem.t === 'CARD' || parentItem.t === 'SUMMARY' || parentItem.t === 'TABLE' || parentItem.t === 'TD' || CoreFns.isAlert(objPath) || parentItem.t === 'TABITEM' || parentItem.t === 'CONTAINER'){
      }else if (parentItem.t === 'HFLEX' || parentItem.t === 'TR' || parentItem.t === 'TABS' || parentItem.t === 'GALLERY'){
        txt = 'Left';
        lText = 'left';
        txt1 = 'Right'
        ltxt1 = 'right';
      }else{
        console.warn(parentItem);
      }
    }

    if (+ind > 0){
      thingsToChange.push({t:'form', n:'Shift ' + txt, fo:{t:'Execute', ic:'akar-icons:arrow-'+lText+'-thick', f:shiftX(-1)}});
    }
    if (+ind < orderedKeys.length - 1){
      thingsToChange.push({t:'form', n:'Shift ' + txt1, fo:{t:'Execute', ic:'akar-icons:arrow-'+ltxt1+'-thick', f:shiftX(+1)}});
    }    

    var startingOrd = -Infinity;
    var gotRepeatNos = false;
    for (var i = 0; i < orderedKeys.length; i++){
      if (parents[orderedKeys[i]] && parents[orderedKeys[i]].s && parents[orderedKeys[i]].s.ord){
        var thisItemNos = parents[orderedKeys[i]].s.ord.v;
        if (thisItemNos === startingOrd){
          gotRepeatNos = true;
          break;
        }
        startingOrd = thisItemNos;        
      }
    }

    if (gotRepeatNos){

      function cleanUpOrdering(e){ 
        var changes = orderedKeys.map((aKey, index)=>{
          return {t:'w',w: setOfContainersPath.concat([aKey, 's', 'ord', 'v']), n:+index}          
        })
        organicChanges(changes);
      }
      thingsToChange.push({t:'form', n:'Clean up ordering.', fo:{t:'Execute', doNotCheckError:1, ic:'eos-icons:cleanup', f:cleanUpOrdering}});

    }

    if (isNavItem){

      var navBarPath = CoreFns.filterPathStopBefore(objPath, 3);
      var thisNav = CoreFns.goDownPath(currentList, navBarPath);
      if (thisNav.on && thisNav.on !== 1){
        var newNewPath = ['cn', thisNav.on, 'nv'];
        var newNewItem;
        try{
          newNewItem = CoreFns.goDownPath(currentList, newNewPath);
          thisNav = newNewItem;
          navBarPath = newNewPath;
        }catch(err){
        }
      }
      if (thisNav && thisNav.s && thisNav.s.navbarCluster){
        var whichCluster = objPath[3];
        function jumpTo(newCluster){
          return function(e){
            var addPath = navBarPath.concat([newCluster]);
            var ord = ResponsiveFns.getNextOrd(currentList, addPath);
            var uuid = CoreFns.uuidScoped(userNos, currentList, addPath, []);  
            var itemHere = JSON.parse(JSON.stringify(thisItem));
            itemHere.s.ord = {t:'int',v:ord};
            var changes = [{t:'w',w:addPath.concat([uuid]),n:itemHere}, {t:'r',w: CoreFns.filterPathStopBefore(objPath, 4),i:objPath[4]}];
            organicChanges(changes);
          }
        }

        if (whichCluster === 'i'){
          thingsToChange.push({t:'form', n:'Move to Center cluster', fo:{t:'Execute', ic:'ant-design:double-right-outlined', f:jumpTo('ic')}});            
        }else if (whichCluster === 'ic'){
          thingsToChange.push({t:'form', n:'Move to Left cluster', fo:{t:'Execute', ic:'ant-design:double-left-outlined', f:jumpTo('i')}});            
          thingsToChange.push({t:'form', n:'Move to Right cluster', fo:{t:'Execute', ic:'ant-design:double-right-outlined', f:jumpTo('ir')}});            
          // pieces.push({t:'Move to Left cluster',a:0,f:jumpTo('i'), i:'ant-design:double-left-outlined'});
          // pieces.push({t:'Move to Right cluster',a:0,f:jumpTo('ir'), i:'ant-design:double-right-outlined'});
        }else if (whichCluster === 'ir'){
          thingsToChange.push({t:'form', n:'Move to Center cluster', fo:{t:'Execute', ic:'ant-design:double-left-outlined', f:jumpTo('ic')}});            
        }
      }


    }else if (t === 'itemPosition'){

      if (thisItem.t === 'CONTAINER'){
        if (+ind > 0){
          var secondKey = orderedKeys[ind -1 ];
          var secondObject = parents[secondKey];
          if (secondObject.t === 'CONTAINER'){
            thingsToChange.push({t:'form', n:'Combine Contents with Previous Panel', fo:{t:'Execute', ic:'codicon:combine', f:executeCombineFn(setOfContainersPath, thisP, [{t:'i', checkOrd:1}], ind, 'item')}});
          }
        }
      }
    }
    return thingsToChange;

  }


  if (t === 'icon' || t === 'modifiers'){
    return [{t}];
  }else if (t === 'text'){
    return [{t:'form', f:1, fo:{t:'Text String'}, n:'Label',i:'text', h:thisItem.q}];
  }else if (t === 'data'){
    var it1 = thisItem.t;
    if (it1 === 'LINECHART'){
      return [{t:'data', i:'line'}];
    }

  }else if (t === 'common'){

    var commonI;
    if (CoreFns.isAlert(objPath)){
      commonI = 'alert';
    }else if (objPath.length === 3 && isNavPath(objPath)){
      commonI = 'navBar';
    }else{
      commonI = thisItem.t;
    }

    return [{t:'common', i:commonI}];
  }else if (t === 'buttonColor'){
    thingsToChange = [{t:'samples2', n:'Color Set',i:'buttonColorSet'}];
    if (thisItem && thisItem.s){
      if (thisItem.s.buttonColorSet){
        thingsToChange.push({t:'color', n:'Background Color', i:'backgroundColor'});
        thingsToChange.push({t:'color', n:'Hover Color', i:'hoverColor'});
      }else{
        thingsToChange = thingsToChange.concat([{t:'samples', n:'Outline', i:'buttonOutline'}, {t:'samples', n:'Color', i:'buttonColor'}, {t:'tags', n:'Tag', i:'buttonColor'}])
      }
    }
    return thingsToChange;
  }else if (t === 'tooltip'){
    thingsToChange = [doBoolean('Add Tooltip', 'tooltipSet', 'A tooltip is a pop-up that appears when the user hovers over the element.')];
    if (thisItem && thisItem.s && thisItem.s.tooltipSet){
        thingsToChange.push({t:'form', n:'Text',i:'toolText', f:1, fo:{t:'Text String'}});
        thingsToChange.push({t:'samples2', n:'Location',i:'tooltipLocation'});
        thingsToChange.push({t:'samples2', n:'Shade', i:'tooltipShade'});
    }
    return thingsToChange;

  }else if (t === 'screenPosition'){

    var screenPath = [objPath[0], objPath[1], '_s'];
    var screens = CoreFns.goDownPath(currentList, screenPath);
    var screenKeys = CoreFns.sortedKeyList(screens);
    var aScreenKey = objPath[3];

    var index = 0;
    for (var i9 = 0; i9 < screenKeys.length; i9++){
      if (screenKeys[i9] === aScreenKey){
        index = i9;
        break;
      }
    }


    function shift(replaceWith){

      return function(e){
        var firstKey = screenKeys[index];
        var secondKey = screenKeys[index + replaceWith];

        var firstOrd = screens[firstKey].ord;
        var secondOrd = screens[secondKey].ord;
        var changes = [];
        if (firstOrd === secondOrd){
          if (replaceWith === -1){
            changes.push({t:'w', w:screenPath.concat([secondKey, 'ord']), n:firstOrd + 1});
            for (var i7 = index + 1; i7 < screenKeys.length; i7++){
              changes.push({t:'w', w:screenPath.concat([screenKeys[i7], 'ord']), n:firstOrd + 5 + i7 - index});
            }
          }else{
            changes.push({t:'w', w:screenPath.concat([firstKey, 'ord']), n:firstOrd + 1});
            for (var i71 = index + 2; i71 < screenKeys.length; i71++){
              changes.push({t:'w', w:screenPath.concat([screenKeys[i71], 'ord']), n:firstOrd + 5 + i71 - index});
            }
          }
        }else{
          changes = [{t:'w',w: screenPath.concat([firstKey, 'ord']), n:secondOrd}, {t:'w',w: screenPath.concat([secondKey, 'ord']), n:firstOrd}];
        }
        organicChanges(changes);
      }
    }

    if (screenKeys.length === 0){
      thingsToChange.push({t:'instructions', n:'Panels cannot be shifted around because there is only one panel.'});      
    }else{
      thingsToChange.push({t:'instructions', n:'You can drag a panel (via its yellow border) to drop it into a different position. These possible locations are indicated with a "Drop Panel Here" text when you start dragging.'});      
    }

    if (+index > 0){
      thingsToChange.push({t:'form', n:'Shift Panel Up', fo:{t:'Execute', ic:'akar-icons:arrow-up-thick', f:shift(-1)}});
    }
    if (+index < screenKeys.length - 1){
      thingsToChange.push({t:'form', n:'Shift Panel Down', fo:{t:'Execute', ic:'akar-icons:arrow-down-thick', f:shift(+1), }});
    }

    if (+index > 0){

      thingsToChange.push({t:'form', n:'Combine Contents with Previous Panel', fo:{t:'Execute', ic:'codicon:combine', f:executeCombineFn(screenPath, aScreenKey, [{t:'al', checkOrd:1} , {t:'i', checkOrd:0}, {t:'k', checkOrd:1}], index, 'screen')}});
    }


    return thingsToChange;
  }else if (t === 'navBarSource'){

    thingsToChange.push({t:'navBarSource'});
    return thingsToChange;
  }else if (t === 'style'){

    if (thisItem){

      var it = thisItem.t;
      if (objPath.length === 4){
        var nStyles1 = []
        additionalsForAdmin(nStyles1, 'Panel'); //PANEL
        return nStyles1;
      }else if (objPath.length === 2 && objPath[0] === 'pu'){
        return [{t:'distance',i:'paddingOpacity'}];

      }else if (CoreFns.isAlert(objPath)){
        // thingsToChange = [{t:'samples', n:'Outline', i:'buttonOutline'}, {t:'samples', n:'Color', i:'buttonColor'}];
        additionalsForAdmin(thingsToChange, 'Banner'); //, 'ALERT'
        return thingsToChange;

      }else if (isNavItself){
        var nStyles = [doBoolean('Collapse items for narrow screens', 'navbarCollapse', ''), doBoolean('Cluster items into left/center/right', 'navbarCluster', ''), doBoolean('Stick Bar to the top of the screen', 'navbarSticky', ''),
        {t:'samples2', n:'Text Shade',i:'navbarTextShade'}, {t:'samples2', n:'Hover Effect',i:'hoverEffect'}];
        if (thisItem.s && thisItem.s.navbarCollapse){       
          nStyles.push({t:'color', n:'Menu Icon Color', i:'menuIconColor'})
        }
        additionalsForAdmin(nStyles, 'Navigation Bar'); //, 'navBar'
        return nStyles;
      }else if (objPath.length === 1 && objPath[0] === 'fo'){
        var nStyles2 = [doBoolean('Stick Footer to the bottom of the screen', 'footerSticky', '')];
        additionalsForAdmin(nStyles2, 'Footer'); //, 'FOOTER'
        return nStyles2;

      }else{
        if (it === 'CARD'){
        }else if (it === 'CONTAINER'){
          thingsToChange = [doBoolean('Styled Container', 'styled', 'Choosing Yes sets a max-width for the container. Choosing No sets the width to 100%, and the default styles for container will not be used.')];
        }else if (it === 'VIDEO'){
          // doBoolean('Auto-Play', 'autoplay', '')
          thingsToChange = [{t:'form', n:'Youtube Video ID',i:'videoId', h:'The Video Id of https://www.youtube.com/watch?v=jHWKtQHXVJg would be "jHWKtQHXVJg"', f:1, fo:{t:'Text String'}, c:[{t:'noBlank'}]}];
          if (objPath[4] === 'k'){
            thingsToChange.push({t:'samples2', n:'Dimensions',i:'vDimensions'});
          }

        }else if (it === 'TIMER'){
          thingsToChange = [{t:'form', n:'Reference Time',i:'time', h:'', f:1, fo:{t:'UInteger', sp:'dateTime'}, c:[]}, doBoolean('Time to Reference', 'reverse', ''), doBoolean('Stop at 0', 'stopAt0', ''), doBoolean('Hide Seconds if Days are shown', 'hideSeconds', ''), {t:'samples2', n:'Timer Type', i:'timerType'}];
        }else if (it === 'SUMMARY'){
          thingsToChange = [{t:'samples2', n:'Style',i:'detailsStyle'}];

        }else if (it === 'INPUT'){
          var inputType =  getOrig(currentList, 'inputType', objPath);
          thingsToChange = [{t:'dropDown', n:'Input Type', i:'inputType', v:'inputType', o:[{n:'Decimal', i:'Decimal', a:'mdi:decimal'}, {n:'Integer', i:'Integer', a:'carbon:character-integer'}, {n:'Positive Integer', i:'UInteger', a:'mdi:numeric-positive-1'}, {n:'Text', i:'Text String', a:'bx:text'}, {n:'Long Text', i:'Long Text', a:'mdi:text-long'}, {n:'Dropdown', i:'Single Select', a:'carbon:list-dropdown'}, {n:'Radio Buttons', i:'Radio', a:'majesticons:radio-list'}]}];
          if (inputType === 'Long Text'){
            thingsToChange.push({t:'distance', i:'numRows'});
          }
          var allowMultiple = false;
          if (inputType === 'Text String' || inputType === 'Integer' || inputType === 'UInteger' || inputType === 'Decimal' || inputType === 'Long Text' || inputType === 'Single Select' || inputType === 'Radio'){
            var fo;
            if (inputType === 'Long Text' || inputType === 'Single Select'){
              fo = {t:'Text String'};
            }else if (inputType === 'Radio'){
              allowMultiple = getOrigNoV(currentList, 'allowMultiple', objPath);
              if (allowMultiple){
                fo = {t:'ListType', c:{t:'Text String'}};
              }else{
                fo = {t:'Text String'};
              }
            }else{
              fo = {t:inputType};
            }

            if (inputType === 'Radio'){
              thingsToChange.push(doBoolean('Allow multiple answers', 'allowMultiple', 'Allow the user to select multiple replies'));
            }else if (inputType === 'Single Select'){
            }else{
              thingsToChange.push({t:'form', n:'Placeholder',i:'placeholder', f:1, fo:{t:'Text String'}});
            }
            if (inputType === 'UInteger' || inputType === 'Integer' || inputType === 'Decimal'){
              thingsToChange.push(doBoolean('Minimum Value?', 'gotMinVal', 'Show an error message if input is below specified amount'));
              var gotMinVal =  getOrigNoV(currentList, 'gotMinVal', objPath);
              if (gotMinVal){
                thingsToChange.push({t:'form', n:'Specify Minimum Value',i:'minVal' + inputType, f:1, fo:{t:inputType}, c:[]});
                thingsToChange.push({t:'form', n:'Error Text',i:'minValErrorText', h:'Text to be shown if minimum value is not met', f:1, fo:{t:'Text String'}, c:[{t:'noBlank'}]});

              }

              thingsToChange.push(doBoolean('Maximum Value?', 'gotMaxVal', 'Show an error message if input is above specified amount'));
              var gotMaxVal =  getOrigNoV(currentList, 'gotMaxVal', objPath);
              if (gotMaxVal){
                thingsToChange.push({t:'form', n:'Specify Maximum Value',i:'maxVal' + inputType, f:1, fo:{t:inputType}, c:[]});
                thingsToChange.push({t:'form', n:'Error Text',i:'maxValErrorText', h:'Text to be shown if maximum value is exceeded', f:1, fo:{t:'Text String'}, c:[{t:'noBlank'}]});

              }
            }
            if (allowMultiple){
              thingsToChange.push({t:'listOfItems', n:'Default Value', i:'valueListString', f:{t:'ListType', c:{t:'Text String'}}})
            }else{
              thingsToChange.push({t:'form', n:'Default Value',i:StyleFunctions.getRelevantValueTgt(inputType, allowMultiple), f:1, fo});

            }
          }
          if (inputType === 'Text String' || inputType === 'Integer' || inputType === 'UInteger' || inputType === 'Decimal' || inputType === 'Long Text'){
            thingsToChange.push({t:'samples', n:'Size', i:'inputSize'});
            thingsToChange.push({t:'samples2', n:'Text Alignment', i:'textAlignment'});
          }

          if (inputType === 'Single Select'){
            thingsToChange.push({t:'listOfItems', n:'Options', i:'options', f:{t:'ListType', c:{t:'Text String'}}})
            thingsToChange.push({t:'samples2', n:'Dropdown Style', i:'selectStyle'});
            var selectStyle =  getOrig(currentList, 'selectStyle', objPath);
            if (selectStyle === 'square'){
              thingsToChange.push({t:'samples2', n:'Shade when Hover', i:'shadeWhenHover'});
            }
            thingsToChange.push({t:'samples2', n:'Text Alignment', i:'textAlignment'});
          }else if (inputType === 'Radio'){
            thingsToChange.push({t:'listOfItems', n:'Options', i:'options', f:{t:'ListType', c:{t:'Text String'}}})
            thingsToChange.push({t:'samples2', n:'Tick', i:'radioTick'});
            thingsToChange.push({t:'samples2', n:'Border', i:'radioShape'});
            thingsToChange.push({t:'color', n:'Outline Color', i:'outlineColor'});
            thingsToChange.push({t:'color', n:'Checkmark Color', i:'tickColor'});
          }
          addBIUSet(thingsToChange);
          thingsToChange.push(doBooleanWithFormula('Disabled', 'disabled', ''));
        }else if (it === 'BUTTON'){
          thingsToChange = [{t:'samples', n:'Size', i:'buttonSize'}, doBooleanWithFormula('Disabled', 'disabled', '')];
          addBIUSet(thingsToChange);
        }else if (it === 'HFLEX'){
          thingsToChange = [{t:'samples2', n:'Horizontal Alignment',i:'justifyContent'}, {t:'samples2', n:'Vertical Alignment', i:'alignItems'}, {t:'instructions', n:'Rows are wrappers for elements. Each row should include a set of elements where the sum of their widths add up to 12 columns or fewer. If their widths add up to more than 12 columns, then those exceeding will wrap onto the next line. However, there are cases where this might not apply, especially for shorter rows. In a 12 column layout, one column will be 8.333% (100%/12) of the total width. The minimum width of a 12 column layout is then 360px due to default left and right padding of 15px per column. Remove this padding between your elements by choosing None for "Spaces between Elements".'}, {t:'samples2', n:'Spaces between Elements',i:'noGutter'}, {t:'distance', n:'Row Height', i:'rowHeight'}];
        }else if (it === 'navBrand'){
          thingsToChange = [doBoolean('Got Logo?', 'gotLogo', ''), doBoolean('Got Text?', 'gotText', '')];
          if (thisItem.s.gotText){
            addBIUSet(thingsToChange);
          }
          if (thisItem.s.gotLogo){
            thingsToChange.push({t:'distance', i:'logoWidth', f:{t:'Font Size'}});
            thingsToChange.push({t:'form', n:'Image', i:'src', h:'Specify image', f:0, fo:{t:'Text String', sp:'image'}});
            if (thisItem.s.gotText){
              thingsToChange.push({t:'distance',i:'spacingGap', f:{t:'Font Size'}});
            }
          }
//it === 'GALLERYITEM';
        }else if (it === 'navLink' || it === 'navDropDown' || it === 'SPAN'){
          addBIUSet(thingsToChange);
          if (it === 'navDropDown'){
            thingsToChange.push(doBoolean('Specify Width', 'specWidth', ''));
            if (getOrig(currentList, 'specWidth', objPath)){
              thingsToChange.push({t:'distance',i:'width'});
            }
          }
        }else if (it === 'IMG'){
          thingsToChange.push({t:'form', n:'Image', i:'src', isFromScreen:true, h:'Specify image', f:1, fo:{t:'Text String', sp:'image'}});
        }else if (it === 'SPACE'){
        }else if (it === 'SUMMARYDIV'){
          if (isClickingOnContentDiv){
            thingsToChange.push({t:'samples2', n:'Horizontal Alignment', i:'textAlignment'});
          }
        }else if (it === 'ICON'){
        }else if (it === 'DIV' ){
          thingsToChange.push({t:'distance', n:'Line Height', i:'lineHeight'});
          thingsToChange.push({t:'samples2', n:'Horizontal Alignment', i:'textAlignment'});
          thingsToChange.push(doBoolean('Wrap Text', 'overflowWrap', ''));
        }else if (it === 'TABLE'){
          thingsToChange = [doBoolean('Designate First Row as Header Row', 'firstRowHeader', ''), {t:'samples2', n:'Hover over rows',i:'tableHover'}, {t:'samples2', n:'Striped rows',i:'tableStriped'}, {t:'samples2', n:'Dark rows',i:'tableDark'}, {t:'samples2', n:'Table Border',i:'tableBordered'}];
        }else if (it === 'TR'){
        }else if (StyleFunctions.isChart(it)){

          thingsToChange = [doBooleanReverse('Show Grid', 'hideGrid', ''), doBooleanReverse('Show X Axis', 'hideXAxis', '')];
          var hideX =  getOrig(currentList, 'hideXAxis', objPath);
          if (!hideX){
            thingsToChange.push({t:'color', n:'X Axis Color', i:'xColor'})
          }

          thingsToChange.push(doBooleanReverse('Show Y Axis', 'hideYAxis', ''));
          var hideY =  getOrig(currentList, 'hideYAxis', objPath);
          if (!hideY){
            thingsToChange.push({t:'color', n:'Y Axis Color', i:'yColor'})
          }

          thingsToChange.push({t:'distance',i:'fontSize', lim:['px'],f:{t:'Font Size'}});
          thingsToChange.push(doBooleanReverse('Show Legend','hideLegend', ''));
          thingsToChange.push(doBooleanReverse('Show Tooltip', 'hideToolTip', ''));

        }else if (it === 'TABITEM'){
        }else if (it === 'GALLERY'){
          thingsToChange = [{t:'samples2', n:'Hover Effect',i:'galleryHover'}, {t:'distance', i:'width'}, {t:'distance', i:'minHeight'},{t:'distance', i:'maxHeight'}, {t:'samples2', n:'Movement Icons (when click on Gallery)',i:'mvtIcon'}, doBoolean('Buttons Outside Picture (when click on Gallery)', 'buttonsOutside', ''), {t:'distance',i:'colWidthInternal'}];
        }else if (it === 'TABS'){
          thingsToChange = [doBoolean('Bold Selected','sBold', ''), doBoolean('Bold Unselected', 'uBold', ''), doBoolean('Underline Selected', 'sUnderline', ''), doBoolean('Underline Unselected', 'uUnderline', '')]
        }else{
          console.log(objPath);
          console.warn(thisItem);
          console.log(it);
        }


        if (objPath.length > 6){
          var parentalPiece = CoreFns.goDownPath(currentList, objPath, 2);
          if (parentalPiece.t === 'HFLEX' || parentalPiece.t === 'TD' || parentalPiece.t === 'TABITEM'){
            thingsToChange.push({t:'distance',i:'colWidth'});
            thingsToChange.push({t:'distance',i:'mt'});
            thingsToChange.push({t:'distance',i:'mb'});
            thingsToChange.push({t:'distance',i:'ml'});
            thingsToChange.push({t:'distance',i:'mr'});
            if (it === 'INPUT'){
              thingsToChange.push(doBoolean('Match Height of Container', 'matchHeight', '')); 
            }

            if (parentalPiece.t === 'HFLEX'){
              if (it === 'INPUT' || it === 'IMG'){
                thingsToChange.push({t:'samples2', n:'Vertical Alignment', i:'vTop'});
              }

            }
            // thingsToChange.push({t:'boolean',i:'colWidth'});
          }

          if ((it === 'SUMMARYDIV' && !isClickingOnContentDiv) || parentalPiece.t === 'HFLEX'  || parentalPiece.t === 'CONTAINER' || parentalPiece.t === 'CARD' || parentalPiece.t === 'TABLE' || parentalPiece.t === 'GALLERY') {
            thingsToChange.push({t:'rFormula'});
          }

        }else if (objPath.length === 6){
          if (StyleFunctions.isFirstLevelAbsolute(objPath)){
            thingsToChange.push({t:'form', n:'Ordering of items', i:'zIndex', h:'Values < 0 go behind the relative images; > 0 in front of. The smaller the number, the further back it goes.', f:0, fo:{t:'Integer'}});
          }else{
            thingsToChange.push({t:'distance',i:'mt'});
            thingsToChange.push({t:'distance',i:'mb'});
            thingsToChange.push({t:'distance',i:'ml'});
            thingsToChange.push({t:'distance',i:'mr'});
          }
        }

        if (StyleFunctions.gotPaddingSet(it) || it === 'GALLERY' || it === 'TABS'){
          thingsToChange.push({t:'samples2', n:'Padding',i:'indvPadding'});
          // thingsToChange.push({t:'boolean', n:'Specify Padding Values Individually',i:'indvPadding'});
          if (thisItem.s.indvPadding){
            if (thisItem.s.indvPadding.v === 1){
              thingsToChange.push({t:'distance', n:'Padding Left', i:'paddingLeft'});
              thingsToChange.push({t:'distance', n:'Padding Right', i:'paddingRight'});
              thingsToChange.push({t:'distance', n:'Padding Top', i:'paddingTop'});
              thingsToChange.push({t:'distance', n:'Padding Bottom', i:'paddingBottom'});
            }else if (thisItem.s.indvPadding.v === 0){
              thingsToChange.push({t:'distance', n:'Padding', i:'padding'});
            }
          }
        }

        if (StyleFunctions.canScroll(it)){
            thingsToChange.push({t:'samples2', n:'Fade in', i:'scrollIn'}); 
        }

        thingsToChange.push( doBooleanWithFormula('Hide this Element', 'gHideWhen', 'Specify conditions where this element should be hidden from view [element only disappears in the preview mode]'));
        
        if (it === 'IMG' || it === 'DIV' || it === 'BUTTON' || it === 'VIDEO' || it === 'INPUT' || it === 'TABS' || it === 'GALLERY' || it === 'ICON' || it === 'TABLE' || it === 'SPACE'){


          function executeFn(){
              var origOrd = thisItem.s.ord.v;
              thisItem.s.ord.v = 0;
              var origWidth = thisItem.s.colWidth;
              thisItem.s.colWidth = {t: 'bsu', v: 12};
              var newItem = {t:'CONTAINER', s:{styled:0, ord: {t: 'int', v: origOrd}}, oc:{}, _na:'Container for ' + thisItem._na, i:{

                '1':{t:'HFLEX', s:{ord: {t: 'int', v: 0}}, oc:{}, _na:'Row for ' + thisItem._na, i:{
                  '1':thisItem
                }},

              }};
              if (origWidth){
                newItem.s.colWidth = origWidth;
              }

              var addChanges = doAddChanges(currentList, objPath, objPath.concat(['i', '1', 'i', '1']), chains, changeTab);
              organicChanges([{t:'w',w:objPath, n:newItem}].concat(addChanges));
          }

          thingsToChange.push({t:'form', n:'Wrap Element in Container', fo:{t:'Execute', ic:'bi:box-arrow-in-up', f:executeFn}});
        }
        additionalsForAdmin(thingsToChange, CoreFns.getElementInfo(thisItem.t).t); //, 'item'


      }
    }


    return thingsToChange;      
  }else if (t === 'images'){
    return [{t:'form', n:'', i:'srcList', h:'', f:1, fo:{t:'ListType', c:{t:'Text String', sp:'image'}}}];
  }else if (t === 'options'){
    return [{t:'form', n:'Options', i:'capList', h:'', f:1, fo:{t:'ListType', c:{t:'Text String'}}}, {t:'color', n:'Outline Color', i:'outlineColor'}, {t:'color', n:'Checkmark Color', i:'tickColor'}];

  }else if (t === 'captions'){

    var thingsToChange2 = [doBooleanReverse('Show Captions', 'hideCaption')];
    if (!thisItem.s.hideCaption){
      thingsToChange2.push({t:'form', n:'Captions', i:'capList', h:'', f:1, fo:{t:'ListType', c:{t:'Text String'}}});
      thingsToChange2.push({t:'samples2', n:'Text Alignment', i:'textAlignment'});
      addBIUSet(thingsToChange2);
      thingsToChange2.push({t:'color', n:'Text Color', i:'color'});
    }
    return thingsToChange2;

  }else if (t === 'spanFontFamily'){
    return [{t:'spanFontFamily'}];

  }else if (t === 'border'){
    function removeBorderFn(e){
      var changes = [{t:'r',w:objPath.concat(['s']),i:'borderWidth'}, {t:'r',w:objPath.concat(['s']),i:'borderColor'}
          , {t:'r',w:objPath.concat(['s']),i:'borderRadius'}
          , {t:'r',w:objPath.concat(['s']),i:'borderTopLeftRadius'}
          , {t:'r',w:objPath.concat(['s']),i:'borderTopRightRadius'}
          , {t:'r',w:objPath.concat(['s']),i:'borderBottomRightRadius'}
          , {t:'r',w:objPath.concat(['s']),i:'borderBottomLeftRadius'}
          , {t:'r',w:objPath.concat(['s']),i:'borderStyle'}];
      if(organicChanges){
        organicChanges(changes);
      }
    }

    if (thisItem){
      if (thisItem.s){
        thingsToChange =  [{t:'distance', n:'Width', i:'borderWidth'}, {t:'color', n:'Color', i:'borderColor'}, {t:'samples', n:'Style', i:'borderStyle'}, doBoolean('Specify Radius Individually', 'indvRadius', '')];

        if (thisItem.s.indvRadius){
          thingsToChange.push({t:'distance', n:'Top Left Radius', i:'borderTopLeftRadius'});
          thingsToChange.push({t:'distance', n:'Top Right Radius', i:'borderTopRightRadius'});
          thingsToChange.push({t:'distance', n:'Bottom Left Radius', i:'borderBottomLeftRadius'});
          thingsToChange.push({t:'distance', n:'Bottom Right Radius', i:'borderBottomRightRadius'});

        }else{
          thingsToChange.push({t:'distance', n:'Radius', i:'borderRadius'});
        }

        if (thisItem.t === 'TIMER'){
          if (thisItem.s.timerType && thisItem.s.timerType.v === 'narrowTimer'){
          }else{
            thingsToChange.push({t:'distance', n:'Counter Padding', i:'counterPadding'});
            thingsToChange.push({t:'distance', n:'Counter Radius', i:'counterRadius'});
          }
        }

        if (thisItem.s.borderWidth){
          thingsToChange.push({t:'form', n:'Remove Border', fo:{t:'Execute', ic:'el:remove-circle', f:removeBorderFn}});
        }

      }

    }  

    return thingsToChange;
  }else if (t === 'colorSet'){
    return isShowingSomeDropDown.colors.map((aSecond, index)=>{
      return {t:'color', n:aSecond.t, i:aSecond.i, f:aSecond.f ? {t:'Color'} : null}
    })
  }else if (t === 'textColor'){
    return [{t:'color', n:'Text Color', i:'color', f:{t:'Color'}}];
  }else if (t === 'legendAndTextColor'){
    return [{t:'color', n:'Text Color', i:'color', f:{t:'Color'}}, {t:'color', n:'Legend Color', i:'legendColor', f:{t:'Color'}}];
  }else if (t === 'crop'){
    if (objPath.length === 6 && objPath[4] === 'i'){
      return [
        // {t:'distance', i:'sca'},
        // {t:'distance', i:'cL'},
        // {t:'distance', i:'cR'},
        // {t:'distance', i:'cT'},
        // {t:'distance', i:'cB'},
        ];
    }else{
      var widthOrHeight =  getOrig(currentList, 'wh', objPath);
      return [{t:'dropDown', n:'Constraint', i:'wh', v:'int', o:[{n:'Width', i:0}, {n:'Height', i:1}]},
      {t:'distance', i:widthOrHeight ? 'height' : 'width'}];
    }
  }else if (t === 'move'){

    var posPath = objPath.concat(['pos']);
    var lr = CoreFns.goDownPath(currentList, posPath.concat(['lr', 'v']));

    function addFnsH(newI){
      return function(){
        var pos = CoreFns.goDownPath(currentList, posPath);
        if (newI === lr){
          return [];
        }

        if (newI === 0){
          var origR = EditorHelpers.reverseScale(pos.r.v, pos.r.t, 'r', insetWidth, insetHeight);
          if (lr === 1){
            var origL = EditorHelpers.reverseScale(pos.l.v, pos.l.t, 'l', insetWidth, insetHeight);
            var w = EditorHelpers.scaledDistance(insetWidth - origR - origL, 'vw', 'w', insetWidth, insetHeight);
            return [{t:'w', w:posPath.concat(['w']), n:{t:'vw', v:w}}];
          }else if (lr === 2){
            var origW = EditorHelpers.reverseScale(pos.w.v, pos.w.t, 'w', insetWidth, insetHeight);
            var l = EditorHelpers.scaledDistance(insetWidth - origR - origW, 'vw', 'l', insetWidth, insetHeight);
            return [{t:'w', w:posPath.concat(['l']), n:{t:'vw', v:l}}];
          }
        }else if (newI === 1){
          var origW1 = EditorHelpers.reverseScale(pos.w.v, pos.w.t, 'w', insetWidth, insetHeight);
          if (lr === 0){
            var origL1 = EditorHelpers.reverseScale(pos.l.v, pos.l.t, 'l', insetWidth, insetHeight);
            var r1 = EditorHelpers.scaledDistance(insetWidth - origL1 - origW1, 'vw', 'r', insetWidth, insetHeight);
            return [{t:'w', w:posPath.concat(['r']), n:{t:'vw', v:r1}}];
          }else if (lr === 2){
            var origR1 = EditorHelpers.reverseScale(pos.r.v, pos.r.t, 'r', insetWidth, insetHeight);
            var l1 = EditorHelpers.scaledDistance(insetWidth - origR1 - origW1, 'vw', 'l', insetWidth, insetHeight);
            return [{t:'w', w:posPath.concat(['l']), n:{t:'vw', v:l1}}];
          }
        }else if (newI === 2){
          var origL2 = EditorHelpers.reverseScale(pos.l.v, pos.l.t, 'l', insetWidth, insetHeight);
          if (lr === 0){
            var origW2 = EditorHelpers.reverseScale(pos.w.v, pos.w.t, 'w', insetWidth, insetHeight);
            var r2 = EditorHelpers.scaledDistance(insetWidth - origL2 - origW2, 'vw', 'r', insetWidth, insetHeight);
            return [{t:'w', w:posPath.concat(['r']), n:{t:'vw', v:r2}}];
          }else if (lr === 1){
            var origR2 = EditorHelpers.reverseScale(pos.r.v, pos.r.t, 'r', insetWidth, insetHeight);
            var w2 = EditorHelpers.scaledDistance(insetWidth - origR2 - origL2, 'vw', 'w', insetWidth, insetHeight);
            return [{t:'w', w:posPath.concat(['w']), n:{t:'vw', v:w2}}];
          }
        }
      }
    }


    var dPieces = [{t:'msg', n:'Drag your item around to move it, or resize the item using the corner circles'}, {t:'dropDown', n:'Horizontal Anchors', i:'lr', v:'int', o:[{n:'Left - Width', i:0, addChangesFn:addFnsH(0)}, {n:'Left - Right', i:1, addChangesFn:addFnsH(1)}, {n:'Width - Right', i:2, addChangesFn:addFnsH(2)}]}];

    if (lr === 0 || lr === 1){
      dPieces.push({t:'distance', i:'l'});
    }
    if (lr === 1 || lr === 2){
      dPieces.push({t:'distance', i:'r'});
    }
    if (lr === 0 || lr === 2){
      dPieces.push({t:'distance', i:'w'});
    }

    dPieces.push({t:'distance', i:'minWidth'});
    dPieces.push({t:'distance', i:'maxWidth'});

    var ud = CoreFns.goDownPath(currentList, objPath.concat(['pos', 'ud', 'v']));


    function addFnsV(newI){
      return function(){
        var pos = CoreFns.goDownPath(currentList, posPath);
        var screenPath = CoreFns.filterPathStopBefore(posPath, 4);
        var thisScreen = CoreFns.goDownPath(currentList, screenPath);
        var screenH = EditorHelpers.reverseScale(thisScreen.h.v, thisScreen.h.t, 'h', insetWidth, insetHeight);

        if (newI === ud){
          return [];
        }

        if (newI === 0){

          if (ud === 5){
              return [{t:'w', w:posPath.concat(['h']), n:{t:'vh', v:50}}];
          }else{
            var origB = EditorHelpers.reverseScale(pos.b.v, pos.b.t, 'b', insetWidth, insetHeight);
            if (ud === 1){
              var origT = EditorHelpers.reverseScale(pos.t.v, pos.t.t, 't', insetWidth, insetHeight);
              var h = EditorHelpers.scaledDistance(screenH - origB - origT, 'vh', 't', insetWidth, insetHeight);
              return [{t:'w', w:posPath.concat(['h']), n:{t:'vh', v:h}}];
            }else if (ud === 2){
              var origH = EditorHelpers.reverseScale(pos.h.v, pos.h.t, 'h', insetWidth, insetHeight);
              var t = EditorHelpers.scaledDistance(screenH - origB - origH, 'vh', 'h', insetWidth, insetHeight);
              return [{t:'w', w:posPath.concat(['t']), n:{t:'vh', v:t}}];
            }else if (ud === 6){
              //see if can be smarter about this.
              return [{t:'w', w:posPath.concat(['h']), n:{t:'vh', v:50}}, {t:'w', w:posPath.concat(['t']), n:{t:'vh', v:5}}];
            }

          }
        }else if (newI === 1){
          var origH1 = 100;
          if (ud === 5|| ud === 6){

            var thisScreenRef2 = screenRefs[objPath.join('_')];
            if (thisScreenRef2){
              origH1 = thisScreenRef2.current.clientHeight;
            }

          }else{
            origH1 = EditorHelpers.reverseScale(pos.h.v, pos.h.t, 'h', insetWidth, insetHeight);
          }
          if (ud === 0 || ud === 5){
            var origT1 = EditorHelpers.reverseScale(pos.t.v, pos.t.t, 't', insetWidth, insetHeight);
            var b1 = EditorHelpers.scaledDistance(screenH - origT1 - origH1, 'vh', 'b', insetWidth, insetHeight);
            return [{t:'w', w:posPath.concat(['b']), n:{t:'vh', v:b1}}];
          }else if (ud === 2 || ud === 6){
            var origB1 = EditorHelpers.reverseScale(pos.b.v, pos.b.t, 'b', insetWidth, insetHeight);
            var t1 = EditorHelpers.scaledDistance(screenH - origB1 - origH1, 'vh', 't', insetWidth, insetHeight);
            return [{t:'w', w:posPath.concat(['t']), n:{t:'vh', v:t1}}];
          }          
        }else if (newI === 2){

          if (ud === 6){
            return [{t:'w', w:posPath.concat(['h']), n:{t:'vh', v:50}}];
          }else{          
            var origT2 = EditorHelpers.reverseScale(pos.t.v, pos.t.t, 't', insetWidth, insetHeight);
            if (ud === 0){
              var origH2 = EditorHelpers.reverseScale(pos.h.v, pos.h.t, 'h', insetWidth, insetHeight);
              var b2 = EditorHelpers.scaledDistance(screenH - origT2 - origH2, 'vh', 'b', insetWidth, insetHeight);
              return [{t:'w', w:posPath.concat(['b']), n:{t:'vh', v:b2}}];
            }else if (ud === 1){
              var origB2 = EditorHelpers.reverseScale(pos.b.v, pos.b.t, 'b', insetWidth, insetHeight);
              var h2 = EditorHelpers.scaledDistance(screenH - origB2 - origT2, 'vh', 'h', insetWidth, insetHeight);
              return [{t:'w', w:posPath.concat(['h']), n:{t:'vh', v:h2}}];
            }else if (ud === 5){ 
              // see if can be smarter about this.
              return [{t:'w', w:posPath.concat(['h']), n:{t:'vh', v:50}}, {t:'w', w:posPath.concat(['b']), n:{t:'vh', v:5}}];
            }
          }
        }else if (newI === 5){ //just top;
          if (ud === 0 || ud === 1){
            return []; //nothing to do cos already got top link;
          }else if (ud === 2){
            var origH5 = EditorHelpers.reverseScale(pos.h.v, pos.h.t, 'h', insetWidth, insetHeight);
            var origB5 = EditorHelpers.reverseScale(pos.b.v, pos.b.t, 'b', insetWidth, insetHeight);
            var t5 = EditorHelpers.scaledDistance(screenH - origB5 - origH5, 'vh', 't', insetWidth, insetHeight);
            return [{t:'w', w:posPath.concat(['t']), n:{t:'vh', v:t5}}];
          }else if (ud === 6){

            var v8 = 5;
            var thisScreenRef = screenRefs[objPath.join('_')];
            if (thisScreenRef){
              var ch8 = thisScreenRef.current.clientHeight;
              var origB8 = EditorHelpers.reverseScale(pos.b.v, pos.b.t, 'b', insetWidth, insetHeight);
              v8 = EditorHelpers.scaledDistance(screenH - origB8 - ch8, 'vh', 't', insetWidth, insetHeight);

            }

            return [{t:'w', w:posPath.concat(['t']), n:{t:'vh', v:v8}}]; 
          }
        }else if (newI === 6){
          if (ud === 1 || ud === 2){
            return []; //nothing to do cos already got bottom link;
          }else if (ud === 0){
            var origH6 = EditorHelpers.reverseScale(pos.h.v, pos.h.t, 'h', insetWidth, insetHeight);
            var origT6 = EditorHelpers.reverseScale(pos.t.v, pos.t.t, 't', insetWidth, insetHeight);
            var b6 = EditorHelpers.scaledDistance(screenH - origT6 - origH6, 'vh', 'b', insetWidth, insetHeight);
            return [{t:'w', w:posPath.concat(['b']), n:{t:'vh', v:b6}}];
          }else if (ud === 5){
            var v7 = 5;

            var thisScreenRef1 = screenRefs[objPath.join('_')];
            if (thisScreenRef1){
              var ch7 = thisScreenRef1.current.clientHeight
              var origT7 = EditorHelpers.reverseScale(pos.t.v, pos.t.t, 't', insetWidth, insetHeight);
              v7 = EditorHelpers.scaledDistance(screenH - origT7 - ch7, 'vh', 'b', insetWidth, insetHeight);

            }

            return [{t:'w', w:posPath.concat(['b']), n:{t:'vh', v:v7}}]; 
          }
        }else if (newI === 3 || newI === 4){


          var infoPath = objPath.concat(['info']);
          var info = CoreFns.goDownPath(currentList, infoPath);
          var lv; var wv; var rv;
          if (pos.l){
            lv = pos.l.v;
          }
          if (pos.w){
            wv = pos.w.v;
          }
          if (pos.r){
            rv = pos.r.v;
          }

          var widthSet = DimensionsFns.getLeftRightWidthFromPosAndValues(pos, lv, wv, rv, insetWidth, insetHeight);
          var desiredWidth = widthSet.width;

          var realH = info.sca.v * (info.oH - info.cT.v - info.cB.v);
          var realW = (info.oW - info.cL.v - info.cR.v);    
          var desiredHeight = desiredWidth * realH / realW;

          if (ud === 4){
            var origB3 = EditorHelpers.reverseScale(pos.b.v, pos.b.t, 'b', insetWidth, insetHeight);
            var t3 = EditorHelpers.scaledDistance(screenH - origB3 - desiredHeight, 'vh', 't', insetWidth, insetHeight);
            return [{t:'w', w:posPath.concat(['t']), n:{t:'vh', v:t3}}];            

          }else if (ud === 3){
            var origT3 = EditorHelpers.reverseScale(pos.t.v, pos.t.t, 't', insetWidth, insetHeight);
            var b3 = EditorHelpers.scaledDistance(screenH - origT3 - desiredHeight, 'vh', 'b', insetWidth, insetHeight);
            return [{t:'w', w:posPath.concat(['b']), n:{t:'vh', v:b3}}];            

          }
        }
      }
    }

    if (ud === 3 || ud === 4){
      dPieces.push({t:'dropDown', n:'Vertical Anchors', i:'ud', v:'int', o:[{n:'Top', a:'akar-icons:align-to-top', i:3, addChangesFn:addFnsV(3)}, {n:'Bottom', a:'akar-icons:align-to-bottom', i:4, addChangesFn:addFnsV(4)}]});
    }else{
      dPieces.push({t:'dropDown', n:'Vertical Anchors', i:'ud', v:'int', o:[{n:'Top - Height', i:0, addChangesFn:addFnsV(0)}, {n:'Top - Bottom', i:1, addChangesFn:addFnsV(1)}, {n:'Height - Bottom', i:2, addChangesFn:addFnsV(2)}, {n:'Top Only (Auto Height)', i:5, addChangesFn:addFnsV(5)}, {n:'Bottom Only (Auto Height)', i:6, addChangesFn:addFnsV(6)}]});
    }

    if (ud === 0 || ud === 1 || ud === 3 || ud === 5){
      dPieces.push({t:'distance', i:'t'})
    }
    if (ud === 1 || ud === 2 || ud === 4 || ud === 6){
      dPieces.push({t:'distance', i:'b'});
    }
    if (ud === 0 || ud === 2){
      dPieces.push({t:'distance', i:'h'})
    }

    dPieces.push({t:'distance', i:'minHeight'});
    dPieces.push({t:'distance', i:'maxHeight'});

    dPieces.push({t:'form', n:'Duplicate', fo:{t:'Execute', ic:'akar-icons:copy', f:duplicateItem(objPath, currentList, organicChanges, userNos, setItemEdited, insetWidth, insetHeight, 'item', setIsShowingSomeDropDown)}});


    return dPieces;
  }else if (t === 'moveScreen'){

    var dPieces1 = [{t:'dropDown', n:'Height', i:'hl', v:'int', o:[{n:'Auto', a:'ic:outline-auto-fix-high', i:0}, {n:'Specify', a:'bytesize:settings', i:1}]}];
    var hlSet = CoreFns.goDownPath(currentList, objPath.concat(['hl']));
    if (hlSet){
      if (hlSet.v){
        dPieces1.push({t:'distance', i:'h'});
      }
    }
    dPieces1.push({t:'distance', i:'minHeight'});
    return dPieces1;
  }else if (t === 'movePage'){
    return [{t:'distance', i:'w'}, {t:'distance', i:'popUpPadding'}];


  }else if (t === 'panelBackground' || t === 'complexBackground'){

    thingsToChange = [{t:'dropDown', i:'backgroundType', v:'raw', o:[{n:'Solid Color', i:false, a:'clarity:color-palette-solid'}, {n:'Image', i:'image',a:'bi:image'}]}];

    var origBackgroundType =  getOrig(currentList, 'backgroundType', objPath);
    if (!origBackgroundType ){
      thingsToChange.push({t:'color', n:'Background Color', i:'backgroundColor', f:{t:'Color'}});
      thingsToChange.push({t:'dropDown', i:'gradient', v:'raw', o:[{n:'With Gradient', i:'gradient', a:'charm:tick'}, {n:'No Gradient', i:false, a:'charm:cross'}]});
      if (getOrig(currentList, 'gradient', objPath)){
        thingsToChange.push({t:'color', n:'Gradient Color', i:'backgroundColor2', f:{t:'Color'}});
        thingsToChange.push({t:'distance', i:'gradDir'});//
      }
    }

    if (origBackgroundType === 'image'){
        thingsToChange.push({t:'form', n:'Image', i:'src', h:'Specify image', f:0, fo:{t:'Text String', sp:'image'}});
        thingsToChange.push(doBoolean('Stretch to Fit', 'stretchToFit', ''));
        if (t === 'panelBackground'){
          if (thisItem && thisItem.s){
            if (thisItem.s.stretchToFit){
            }else{
              thingsToChange.push(doBoolean('Fix Background', 'fixedBackground', ''));
            }
          }
        }
    }

    return thingsToChange;    
  }else{
    console.warn(t);
    return [];
  }
}

function getPotentialErrorsOfAButton(chains, changeTab, isShowingSomeDropDown, currentList, objPath, insetWidth, insetHeight, logInState){
  var p = directoryOfThingsToChange(chains, changeTab, isShowingSomeDropDown, currentList, objPath, insetWidth, insetHeight, false, false, logInState, false, false, false, false, false, false, {});
  return p.filter((aP, index)=>{return aP.i}).map((aP, index)=>{
    return ['s', aP.i];
  })
}


export function allEditButtons(chains, setIsShowingSomeDropDown, isShowingSomeDropDown, itemEdited, currentList, organicChanges, refObject, toggle, setToggle, setItemEdited, insetWidth, insetHeight, onClickItemChangeSelection, userNos, userID, isClickingOnContentDiv, logInState, removeItemFn, tabSelected, hidePanelRelativeItems, setHidePanelRelativeItems, addToExtraScreen, changeTab, otherInfo, setOtherInfo, urlParamsForExecution, urlHeader, centerZoom){

  function addItem(e){
    changeTab('AddElement', 0);
  }

  function clickActionButton(input, itemPath){
    return function(e){

      if (input.t === 'click' || input.t === 'change'){
        var ocSet = CoreFns.goDownPath(currentList, itemPath.concat(['oc']));
        if (!ocSet[input.t]){
          var changes = [{t:'w',w:itemPath.concat(['oc', input.t]), n:{t:''}}];
          organicChanges(changes)
        }
      }

      if (isShowingSomeDropDown && isShowingSomeDropDown.t === input.t){
        setIsShowingSomeDropDown(false);
      }else{
        setIsShowingSomeDropDown(input);
      }

      var sel = document.getSelection();
      if (sel.focusNode){
        var range = document.createRange();
        var b = checkIfNodeBefore(sel);
        if (b){
          range.setStart(sel.focusNode, sel.focusOffset);
          range.setEnd(sel.anchorNode, sel.anchorOffset);
        }else{
          range.setStart(sel.anchorNode, sel.anchorOffset);
          range.setEnd(sel.focusNode, sel.focusOffset);

        }
        sel.removeAllRanges()
        sel.addRange(range);        
      }
    }
  }

  var pieces = [];
  var pathDown;
  if (itemEdited){
    pathDown = itemEdited.path;
  }else{
    return [];
  }
  var thisItem;
  try{
    thisItem = CoreFns.goDownPath(currentList, pathDown);
  }catch(err){

  }

  if (!thisItem){
    return [];
  }else if (itemEdited.t === 'page'){

    pieces.push({a:0,h:'addPanel',f:addItem, i:'material-symbols:add'})      
    if (pathDown[0] === 'pu'){
      pieces.push({a:0,h:'style',f:clickActionButton({t:'style'}, pathDown), i:'clarity:design-line', el:getPotentialErrorsOfAButton(chains, changeTab, {t:'style'}, currentList, pathDown, insetWidth, insetHeight, logInState)})
      pieces.push({a:0,h:'movePage',f:clickActionButton({t:'movePage'}, pathDown), i:'radix-icons:dimensions'})
      pieces.push({a:0,h:'colorSet',f:clickActionButton({t:'colorSet', colors:[{t:'Background', i:'backgroundColor', f:0}]}, pathDown), i:'fluent:color-background-20-filled', el:getPotentialErrorsOfAButton(chains, changeTab, {t:'colorSet', colors:[{t:'Background', i:'backgroundColor', f:0}]}, currentList, pathDown, insetWidth, insetHeight, logInState)})
    }

    function duplicateFE(e){
      var isFEOrPU = itemEdited.path[0];
      var pathDown = [itemEdited.path[0]];
      var aFEKey = itemEdited.path[1];
      var uuid = CoreFns.uuidScoped(userNos, currentList, pathDown, []);  
      var oldPiece = CoreFns.goDownPath(currentList, [isFEOrPU, aFEKey]);
      var oldPieceClean = JSON.parse(JSON.stringify(oldPiece));
      var maxPositionX = ResponsiveFns.getMaxPosition(currentList);
      oldPieceClean.pos = {xP:maxPositionX, yP:0};

      var addChanges = modifyPieceAndAddNewSpans(oldPieceClean, currentList, userNos);
      oldPieceClean.n = uuid;

      var changes = [{t:'w',w:pathDown.concat([uuid]),n:oldPieceClean}].concat(addChanges);
      organicChanges(changes);
      setItemEdited({t:'page', path:[isFEOrPU, uuid]});
      centerZoom();
    }
    pieces.push({t:'Duplicate',a:0,f:duplicateFE, i:'akar-icons:copy'})

    // if (CoreFns.isAdmin(logInState)){
    //   pieces.push({a:0,h:'adminPage',f:clickActionButton({t:'adminPage'}, pathDown), i:'dashicons:admin-tools', el:getPotentialErrorsOfAButton(chains, changeTab, {t:'adminPage'}, currentList, pathDown, insetWidth, insetHeight, logInState)})      
    // }


  }else if (itemEdited.t === 'item'){

    if (thisItem){

      var it = thisItem.t;

      if (CoreFns.isHolder(it)){
        pieces.push({a:0,h:'addItem',f:addItem, i:'material-symbols:add'})
      }

      if (it === 'DIV' || (it === 'SUMMARYDIV' && isClickingOnContentDiv) ){

          var internalVariables = StyleFunctions.getInternalVariables(otherInfo, setOtherInfo, {t:itemEdited.path[0], v:itemEdited.path[1]});
          var ownVariables = StyleFunctions.getOwnVariableDefaultValues(currentList, internalVariables, insetWidth, insetHeight, urlParamsForExecution, 'https://www.cues.sg/dapps/XXXX', chains);

          var pieces1 = getEditButtons(currentList, pathDown, organicChanges, refObject, toggle, setToggle, clickActionButton, ownVariables, urlParamsForExecution, urlHeader, chains, insetWidth, insetHeight, onClickItemChangeSelection, setIsShowingSomeDropDown, userNos, userID);    
          pieces = pieces.concat(pieces1);
      }

      if (it === 'GALLERY'){
        pieces.push({a:0,h:'images',f:clickActionButton({t:'images'}, pathDown), i:'akar-icons:image', el:getPotentialErrorsOfAButton(chains, changeTab, {t:'images'}, currentList, pathDown, insetWidth, insetHeight, logInState)})
        pieces.push({t:'Captions',a:0,h:'captions',f:clickActionButton({t:'captions'}, pathDown), i:'bx:text', el:getPotentialErrorsOfAButton(chains, changeTab, {t:'captions'}, currentList, pathDown, insetWidth, insetHeight, logInState)})
      }

      if (it === 'BUTTON' || (it === 'navBrand' && thisItem.s.gotText) || it === 'navLink' || it === 'navDropDown' || (it === 'SUMMARYDIV' && !isClickingOnContentDiv) || it === 'TABITEM' ){
        pieces.push({a:0,h:'text',f:clickActionButton({t:'text'}, pathDown), i:'bx:text', el:getPotentialErrorsOfAButton(chains, changeTab, {t:'text'}, currentList, pathDown, insetWidth, insetHeight, logInState)})
        var fontA = 0;
        if (thisItem.s && thisItem.s.fontFamily && thisItem.s.fontFamily.v){
          fontA = 1;
        }
        pieces.push({a:fontA,h:'spanFontFamily',f:clickActionButton({t:'spanFontFamily'}, pathDown), i:'bx:font-family', el:getPotentialErrorsOfAButton(chains, changeTab, {t:'spanFontFamily'}, currentList, pathDown, insetWidth, insetHeight, logInState)})
       }

       if ((it === 'GALLERY' && !thisItem.s.hideCaption) || it === 'INPUT'){
        var fontB = 0;
        if (thisItem.s && thisItem.s.fontFamily && thisItem.s.fontFamily.v){
          fontB = 1;
        }
        pieces.push({a:fontB,h:'spanFontFamily',f:clickActionButton({t:'spanFontFamily'}, pathDown), i:'bx:font-family', el:getPotentialErrorsOfAButton(chains, changeTab, {t:'spanFontFamily'}, currentList, pathDown, insetWidth, insetHeight, logInState)})

       }
      

      // || it === 'GALLERYITEM'
      if (StyleFunctions.gotStyleAndMargin(it) || it === 'TR' || it === 'navBrand' || it === 'navLink' || it === 'navDropDown' || it === 'TABITEM' || it === 'SUMMARYDIV' ){
        pieces.push({a:0,h:'style',f:clickActionButton({t:'style'}, pathDown), i:'clarity:design-line', el:getPotentialErrorsOfAButton(chains, changeTab, {t:'style'}, currentList, pathDown, insetWidth, insetHeight, logInState)})
        if (it !== 'SPACE'){
          pieces.push({a:0,h:'common',f:clickActionButton({t:'common'}, pathDown), i:'akar-icons:arrow-cycle', el:false}) //eventually we should check that the templates are still avail.          
        }
      }

      if (StyleFunctions.isChart(it)){
        pieces.push({t:'Data',a:0,h:'data',f:clickActionButton({t:'data'}, pathDown), i:'bi:clipboard-data', el:false})        
      }

      if (it === 'TIMER'){
        if (thisItem && thisItem.s && thisItem.s.timerType && thisItem.s.timerType.v === 'narrowTimer'){
          pieces.push({a:0,h:'textColor',f:clickActionButton({t:'textColor'}, pathDown), i:'eva:color-picker-fill', el:getPotentialErrorsOfAButton(chains, changeTab, {t:'textColor'}, currentList, pathDown, insetWidth, insetHeight, logInState)})
        }else{
          pieces.push({a:0,h:'legendAndTextColor',f:clickActionButton({t:'legendAndTextColor'}, pathDown), i:'eva:color-picker-fill', el:getPotentialErrorsOfAButton(chains, changeTab, {t:'legendAndTextColor'}, currentList, pathDown, insetWidth, insetHeight, logInState)})

        }


      }else if (it === 'INPUT' || it === 'navBrand' || it === 'navLink' || it === 'navDropDown' || it === 'SUMMARY' || it === 'BUTTON'){
        pieces.push({a:0,h:'textColor',f:clickActionButton({t:'textColor'}, pathDown), i:'eva:color-picker-fill', el:getPotentialErrorsOfAButton(chains, changeTab, {t:'textColor'}, currentList, pathDown, insetWidth, insetHeight, logInState)})

      }

      if (it === 'BUTTON'){
        pieces.push({a:0,h:'buttonColor',f:clickActionButton({t:'buttonColor'}, pathDown), i:'fluent:color-background-20-filled', el:getPotentialErrorsOfAButton(chains, changeTab, {t:'buttonColor'}, currentList, pathDown, insetWidth, insetHeight, logInState)})
      }


      if (it === 'TABS'){
        var c1 = [{t:'Selected Text Color', i:'sColor'}, {t:'Unselected Text Color', i:'uColor'}]
        pieces.push({a:0,h:'colorSet',f:clickActionButton({t:'colorSet', colors:c1}, pathDown), i:'eva:color-picker-fill', el:getPotentialErrorsOfAButton(chains, changeTab, {t:'colorSet', colors:c1}, currentList, pathDown, insetWidth, insetHeight, logInState)})

      }


      if (it === 'HFLEX' || it === 'CONTAINER' || it === 'INPUT'){
        pieces.push({a:0,h:'complexBackground',f:clickActionButton({t:'complexBackground'}, pathDown), i:'fluent:color-background-20-filled', el:getPotentialErrorsOfAButton(chains, changeTab, {t:'complexBackground'}, currentList, pathDown, insetWidth, insetHeight, logInState)})
      }else if (it === 'DIV' || it === 'CARD' || it === 'TIMER' || it === 'SUMMARY' || it === 'ICON' || it === 'TR' || it === 'TD' || it === 'TABS' || it === 'navDropDown' || it === 'GALLERY'){


        var gotSecondBackgroundColor = [{t:'Background', i:'backgroundColor',f:1}];
        if (it ==='INPUT'){
          if (thisItem.s.inputType){
            if (thisItem.s.inputType.v === 'Single Select'){
              if (thisItem.s.selectStyle){
                if (thisItem.s.selectStyle.v === 'square'){
                  gotSecondBackgroundColor.push({t:'Background Color of Expanded Area', i:'backgroundColor2'});
                }
              }
            }
          }
        }else if (it === 'TABS'){
          gotSecondBackgroundColor.push({t:'Selected Background Color', i:'sBackgroundColor'});
          gotSecondBackgroundColor.push({t:'Unselected Background Color', i:'uBackgroundColor'});
        }else if (it === 'navDropDown'){
          gotSecondBackgroundColor.push({t:'Menu Background Color', i:'menuBackgroundColor'});
        }
        if (it === 'TIMER'){
          if (thisItem.s && thisItem.s.timerType && thisItem.s.timerType.v === 'narrowTimer'){
          }else{
            gotSecondBackgroundColor.push({t:'Counter Background Color', i:'counterBackgroundColor'});
            gotSecondBackgroundColor.push({t:'Legend Background Color', i:'legendBackgroundColor'});
          }
        }
        pieces.push({a:0,h:'colorSet',f:clickActionButton({t:'colorSet', colors:gotSecondBackgroundColor}, pathDown), i:'fluent:color-background-20-filled', el:getPotentialErrorsOfAButton(chains, changeTab, {t:'colorSet', colors:gotSecondBackgroundColor}, currentList, pathDown, insetWidth, insetHeight, logInState)})
      }


      if (it === 'DIV' || it === 'IMG' || it === 'HFLEX' || it === 'INPUT' || it === 'CARD' || it === 'TIMER' || it === 'CONTAINER' || it === 'BUTTON' || it === 'navDropDown' || it === 'GALLERY'){
        pieces.push({a:0,h:'border',f:clickActionButton({t:'border'}, pathDown), i:'bi:border-outer', el:getPotentialErrorsOfAButton(chains, changeTab, {t:'border'}, currentList, pathDown, insetWidth, insetHeight, logInState)})
      }

      if (it === 'BUTTON' || it === 'ICON'){
        pieces.push({a:0,h:'icon',f:clickActionButton({t:'icon'}, pathDown), i:'arcticons:lawnicons', el:getPotentialErrorsOfAButton(chains, changeTab, {t:'icon'}, currentList, pathDown, insetWidth, insetHeight, logInState)})
      }



      if (it === 'IMG' || it === 'BUTTON' || isNavPath(itemEdited.path) || it === 'ICON' || it === 'CARD' || it === 'HFLEX' || it === 'CONTAINER'){

        var clickA = 0;
        if (thisItem && thisItem.oc && thisItem.oc.click && thisItem.oc.click.t){
          clickA = 1;
        }

        pieces.push({a:clickA,h:'click',f:clickActionButton({t:'click'}, pathDown), i:'icon-park-outline:click', el:[['oc', 'click']]})      
      }else if (it === 'INPUT'){

        var clickB = 0;
        if (thisItem && thisItem.oc && thisItem.oc.change && thisItem.oc.change.t){
          clickB = 1;
        }

        pieces.push({a:clickB,h:'change',f:clickActionButton({t:'change'}, pathDown), i:'material-symbols:change-circle-outline-rounded', el:[['oc', 'change']]})      
        pieces.push({a:0,h:'modifiers',f:clickActionButton({t:'modifiers'}, pathDown), i:'gis:modify-line'})      
      }



      if (it === 'IMG'){
        if (pathDown.length === 6 && pathDown[4] === 'i'){
        }else{
          pieces.push({a:0,h:'crop',f:clickActionButton({t:'crop'}, pathDown), i:'bi:crop'})
        }
      }

      if (it === 'BUTTON' || (it === 'INPUT' && CoreFns.isInputTypeWithTooltip(thisItem.s.inputType.v))){
        var toolA = 0;
        if (thisItem.s && thisItem.s.tooltipSet){
          toolA = 1;
        }
        pieces.push({a:toolA,h:'tooltip',f:clickActionButton({t:'tooltip', colors:gotSecondBackgroundColor}, pathDown), i:'majesticons:tooltip-text-line', el:getPotentialErrorsOfAButton(chains, changeTab, {t:'tooltip', colors:gotSecondBackgroundColor}, currentList, pathDown, insetWidth, insetHeight, logInState)})
      }

      if (!isNavPath(itemEdited.path) && StyleFunctions.isFirstLevel(itemEdited.path) && itemEdited.path[4] === 'i' && itemEdited.path.length === 6){
        pieces.push({a:0,h:'move',f:clickActionButton({t:'move'}, pathDown), i:'radix-icons:dimensions'})
      }else{
        pieces.push({a:0,h:'itemPosition',f:clickActionButton({t:'itemPosition'}, pathDown), i:'ic:baseline-gps-fixed', el:getPotentialErrorsOfAButton(chains, changeTab, {t:'itemPosition'}, currentList, pathDown, insetWidth, insetHeight, logInState)});
      }
      pieces.push({t:'Duplicate',a:0,f:duplicateItem(pathDown, currentList, organicChanges, userNos, setItemEdited, insetWidth, insetHeight, 'item', setIsShowingSomeDropDown), i:'akar-icons:copy'})
    }

  }else if (itemEdited.t === 'screen'){

    pieces.push({a:0,h:'addItem',f:addItem, i:'material-symbols:add'})

    if (itemEdited.path[0] === 'fo' || CoreFns.isAdmin(logInState)){
      pieces.push({a:0,h:'style',f:clickActionButton({t:'style'}, itemEdited.path), i:'clarity:design-line', el:getPotentialErrorsOfAButton(chains, changeTab, {t:'style'}, currentList, itemEdited.path, insetWidth, insetHeight, logInState)})      
    }

    if (itemEdited.path[0] === 'fo'){
      pieces.push({a:0,h:'panelBackground',f:clickActionButton({t:'panelBackground'}, itemEdited.path), i:'fluent:color-background-20-filled', el:getPotentialErrorsOfAButton(chains, changeTab, {t:'panelBackground'}, currentList, itemEdited.path, insetWidth, insetHeight, logInState)})
    }else{
      var screenPath = [itemEdited.path[0], itemEdited.path[1], '_s'];
      var aScreenKey = itemEdited.path[3];
      var screens = {};
      try {
        screens = CoreFns.goDownPath(currentList, screenPath);
      }catch(err){

      }

      if (screens[aScreenKey]){
        var thisScreenPath = screenPath.concat([aScreenKey]);
        pieces.push({a:0,h:'panelBackground',f:clickActionButton({t:'panelBackground'}, thisScreenPath), i:'fluent:color-background-20-filled', el:getPotentialErrorsOfAButton(chains, changeTab, {t:'panelBackground'}, currentList, thisScreenPath, insetWidth, insetHeight, logInState)})
        pieces.push({a:0,h:'moveScreen',f:clickActionButton({t:'moveScreen'}, thisScreenPath), i:'radix-icons:dimensions'})
        pieces.push({a:0,h:'screenPosition',f:clickActionButton({t:'screenPosition'}, thisScreenPath), i:'ic:baseline-gps-fixed', el:getPotentialErrorsOfAButton(chains, changeTab, {t:'screenPosition'}, currentList, thisScreenPath, insetWidth, insetHeight, logInState)})      


        function duplicateScreen(){
          var toAdd = CoreFns.goDownPath(currentList, thisScreenPath);
          var haveFound = false;
          var ord = screens[aScreenKey].ord + 1;
          var reallyAdd = JSON.parse(JSON.stringify(toAdd));

          var addChanges = CoreFns.replaceSpansInSomething(reallyAdd, currentList, userNos);
          reallyAdd.ord = ord;
          var uuid = CoreFns.uuidScoped(userNos, currentList, screenPath, []);  
          var changes = [{t:'w',w:screenPath.concat([uuid]),n:reallyAdd}].concat(addChanges);
          var relevantOrd = ord;

          var screenKeys = CoreFns.sortedKeyList(screens);

          for (var i = 0; i < screenKeys.length; i++){
            if (haveFound){
              var thisOrd = screens[screenKeys[i]].ord;
              if (thisOrd <= relevantOrd){
                thisOrd = relevantOrd + 1;
                changes.push({t:'w', w:screenPath.concat([screenKeys[i], 'ord']), n:thisOrd});
              }
              relevantOrd = thisOrd;
            }
            if (screenKeys[i] === aScreenKey){
              haveFound = true;
            }
          }
          organicChanges(changes);
          setItemEdited({t:'screen', path:screenPath.concat([uuid])});
        }

        pieces.push({t:'Duplicate',a:0,f:duplicateScreen, i:'akar-icons:copy'})

        var thisScreenPathString = thisScreenPath.join(' ');
        if (hidePanelRelativeItems[thisScreenPathString]){
          function showRelatives(){
            delete hidePanelRelativeItems[thisScreenPathString];
            setHidePanelRelativeItems({...hidePanelRelativeItems})
          }
          pieces.push({t:'Show Responsive Items',a:0,f:showRelatives, i:'ic:outline-hide-image'})

        }else{
          function hideRelatives(){
            hidePanelRelativeItems[thisScreenPathString] = 1;
            setHidePanelRelativeItems({...hidePanelRelativeItems})
          }
          pieces.push({t:'Hide Responsive Items',a:0,f:hideRelatives, i:'ic:outline-image'})

        }

        // if (CoreFns.isAdmin(logInState)){
        //   pieces.push({t:'Admin',a:0,h:'admin',f:clickActionButton({t:'admin'}, thisScreenPath), i:'dashicons:admin-tools', el:getPotentialErrorsOfAButton(chains, changeTab, {t:'admin'}, currentList, thisScreenPath, insetWidth, insetHeight, logInState)})      
        // }
      }
    }


  }else if (itemEdited.t === 'asset'){
    var thisAsset = CoreFns.goDownPath(currentList, pathDown);
    if (thisAsset.t === 'SPAN'){
      pieces.push({a:0,h:'text',f:clickActionButton({t:'text'}, pathDown), i:'bx:text', el:getPotentialErrorsOfAButton(chains, changeTab, {t:'text'}, currentList, pathDown, insetWidth, insetHeight, logInState), q:'Please note that the text might be truncated while in the design phase but will be shown in full when launched'});
      pieces.push({a:0,h:'textColor',f:clickActionButton({t:'textColor'}, pathDown), i:'eva:color-picker-fill', el:getPotentialErrorsOfAButton(chains, changeTab, {t:'textColor'}, currentList, pathDown, insetWidth, insetHeight, logInState)})
      pieces.push({a:0,h:'style',f:clickActionButton({t:'style'}, pathDown), i:'clarity:design-line', el:getPotentialErrorsOfAButton(chains, changeTab, {t:'style'}, currentList, pathDown, insetWidth, insetHeight, logInState)})
      pieces.push({a:0,h:'colorSet',f:clickActionButton({t:'colorSet', colors:[{t:'Background',i:'backgroundColor',f:1}]}, pathDown), i:'fluent:color-background-20-filled', el:getPotentialErrorsOfAButton(chains, changeTab, {t:'colorSet', colors:[{t:'Background',i:'backgroundColor',f:1}]}, currentList, pathDown, insetWidth, insetHeight, logInState)})

      var fontC = 0;
      if (thisAsset.s && thisAsset.s.fontFamily && thisAsset.s.fontFamily.v){
        fontC = 1;
      }

      pieces.push({a:fontC,h:'spanFontFamily',f:clickActionButton({t:'spanFontFamily'}, pathDown), i:'bx:font-family', el:getPotentialErrorsOfAButton(chains, changeTab, {t:'spanFontFamily'}, currentList, pathDown, insetWidth, insetHeight, logInState)})

        var clickC = 0;
        if (thisAsset && thisAsset.oc && thisAsset.oc.click && thisAsset.oc.click.t){
          clickC = 1;
        }

      pieces.push({a:clickC,h:'click',f:clickActionButton({t:'click'}, pathDown), i:'icon-park-outline:click', el:[['oc', 'click']]})     

    }

  }else if (itemEdited.t === 'alert'){
    var thisAlert;
    try{
      thisAlert = CoreFns.goDownPath(currentList, pathDown);
    }catch(err){

    }

    pieces.push({a:0,h:'style',f:clickActionButton({t:'style'}, pathDown), i:'clarity:design-line', el:getPotentialErrorsOfAButton(chains, changeTab, {t:'style'}, currentList, pathDown, insetWidth, insetHeight, logInState)})
    pieces.push({a:0,h:'border',f:clickActionButton({t:'border'}, pathDown), i:'bi:border-outer', el:getPotentialErrorsOfAButton(chains, changeTab, {t:'border'}, currentList, pathDown, insetWidth, insetHeight, logInState)})
    // addShiftLeftRights(pieces, pathDown, 'Up', 'Down', currentList, organicChanges);

    pieces.push({a:0,h:'buttonColor',f:clickActionButton({t:'buttonColor'}, pathDown), i:'fluent:color-background-20-filled', el:getPotentialErrorsOfAButton(chains, changeTab, {t:'buttonColor'}, currentList, pathDown, insetWidth, insetHeight, logInState)})

    var clickD = 0;
    if (thisAlert && thisAlert.oc && thisAlert.oc.click && thisAlert.oc.click.t){
      clickD = 1;
    }
    
    pieces.push({a:clickD,h:'click',f:clickActionButton({t:'click'}, pathDown), i:'icon-park-outline:click', el:[['oc', 'click']]})      

    pieces.push({a:0,h:'modifiers',f:clickActionButton({t:'modifiers'}, pathDown), i:'material-symbols:change-circle-outline-rounded'})      

    pieces.push({a:0,h:'itemPosition',f:clickActionButton({t:'itemPosition'}, pathDown), i:'ic:baseline-gps-fixed', el:getPotentialErrorsOfAButton(chains, changeTab, {t:'itemPosition'}, currentList, pathDown, insetWidth, insetHeight, logInState)});

    pieces.push({t:'Duplicate',a:0,f:duplicateItem(pathDown, currentList, organicChanges, userNos, setItemEdited, insetWidth, insetHeight, 'alert', setIsShowingSomeDropDown), i:'akar-icons:copy'});
  }else if (itemEdited.t === 'navBar'){
    
    pieces.push({t:'Source',a:0,h:'navBarSource',f:clickActionButton({t:'navBarSource'}, pathDown), i:'akar-icons:arrow-cycle', el: getPotentialErrorsOfAButton(chains, changeTab, {t:'navBarSource'}, currentList, pathDown, insetWidth, insetHeight,logInState)})
    pieces.push({t:'Style',a:0,h:'style',f:clickActionButton({t:'style'}, pathDown), i:'clarity:design-line', el:getPotentialErrorsOfAButton(chains, changeTab, {t:'style'}, currentList, pathDown, insetWidth, insetHeight,logInState)})

      pieces.push({a:0,h:'complexBackground',f:clickActionButton({t:'complexBackground'}, itemEdited.path), i:'fluent:color-background-20-filled', el:getPotentialErrorsOfAButton(chains, changeTab, {t:'complexBackground'}, currentList, itemEdited.path, insetWidth, insetHeight, logInState)})

    var origCollapse = getOrig(currentList, 'navbarCollapse', pathDown);
    if (origCollapse){
        pieces.push({a:0,h:'icon',f:clickActionButton({t:'icon'}, pathDown), i:'arcticons:lawnicons', el:getPotentialErrorsOfAButton(chains, changeTab, {t:'icon'}, currentList, pathDown, insetWidth, insetHeight, logInState)})
    }
  }
  pieces.push({t:'Delete',a:0,f:removeItemFn, i:'fe:trash'});
  return pieces;  
}

export function getHintNames(h){
  if (h === 'fontFamily' || h === 'spanFontFamily'){
    return 'Font';
  }else if (h === 'addItem'){
    return 'Add Item';
  }else if (h === 'color'){
    return 'Font Color';
  }else if (h === 'fontSize'){
    return 'Font Size';
  }else if (h === 'complexBackground' || h === 'panelBackground'){
    return 'Background Color/Image';
  }else if (h === 'moveScreen'){
    return 'Panel Dimensions'
  }else if (h === 'movePage'){
    return 'Dimensions'
  }else if (h === 'images'){
    return 'Images'
  }else if (h === 'captions'){
    return 'Caption'
  }else if (h === 'addPanel'){
    return 'Add Panel'
  }else if (h === 'tooltip'){
    return 'Tooltip';
  }else if (h === 'move'){
    return 'Dimensions + Position'
  }else if (h === 'crop'){
    return 'Adjust Image'
  }else if (h === 'screenPosition' || h === 'itemPosition'){
    return 'Position'
  }else if (h === 'buttonColor'){
    return 'Colors'
  }else if (h === 'colorSet'){
    return 'Background Colors'
  }else if (h === 'textColor'){
    return 'Text Colors'
  }else if (h === 'legendAndTextColor'){
    return 'Legend Colors'
  }else if (h === 'style'){
    return  'General Styles'
  }else if (h === 'border'){
    return 'Border'
  }else if (h === 'common'){
    return 'Element Reuse'
  }else if (h === 'modifiers'){
    return 'Modify Element'
  }else if (h === 'click'){
    return 'Actions on Click';
  }else if (h === 'change'){
    return 'Actions on Change';
  }else if (h === 'icon'){
    return 'Icon';
  }else if (h === 'text'){
    return 'Label';
  // }else if (h === 'adminPage'){
  //   return 'Create Template';
  }else if (h === 'navBarSource'){
    return 'Source';
  }else if (h === 'data'){
    return 'Data';
  }else{
    console.log(h);
    return '';
  }
}


export function filterPathStartFrom(pathDown, startFrom){
  return pathDown.filter((aP, index)=>{
    return +index >= startFrom;
  })
}

export function getErrorPart(loc, screenPath){
  if (loc[0] === 'as'){
    return filterPathStartFrom(loc, 2);
  }else if (screenPath[4] === 'al'){
    return filterPathStartFrom(loc, screenPath.length);
  }else{
    return filterPathStartFrom(loc, screenPath.length);
  }

}

function getEditButtons(currentList, itemPath, organicChanges, refObject, toggle, setToggle, clickActionButton, ownVariables, urlParamsForExecution, urlHeader, chains, width, height, onClickItemChangeSelection, setIsShowingSomeDropDown, userNos, userID) {
 
    var sel = document.getSelection();
    var inlines5 = getInlinesOfANode(sel.anchorNode, itemPath);
    var doInputActions = ResponsiveFns.doInputActionsFn(itemPath, organicChanges, currentList, userID);

    var ref1 = refObject[itemPath.join('_')];

    var isActiveB = checkActive(inlines5, 'B');
    var isActiveI = checkActive(inlines5, 'I');
    var isActiveU = checkActive(inlines5, 'U');

  //
    return [
      {t:'Bold', i:'ant-design:bold-outlined', a:isActiveB, f:toggleBIU({t:'B',v:'B'}, isActiveB, doInputActions, ref1, itemPath, toggle, setToggle, width, height)},
      {t:'Italics', i:'ant-design:italic-outlined', a:isActiveI, f:toggleBIU({t:'I',v:'I'}, isActiveI, doInputActions, ref1, itemPath, toggle, setToggle, width, height)},
      {t:'Underline', i:'ant-design:underline-outlined', a:isActiveU, f:toggleBIU({t:'U',v:'U'}, isActiveU, doInputActions, ref1, itemPath, toggle, setToggle, width, height)},
      {i:'eva:color-picker-fill', a:0,h:'color', f:clickActionButton({t:'color',v:'C'}, itemPath)},
      {i:'bx:font-size', a:0,h:'fontSize', f:clickActionButton({t:'fontSize'}, itemPath)},
      {i:'bx:font-family', a:0,h:'fontFamily', f:clickActionButton({t:'fontFamily'}, itemPath)},
      {t:'Rich Dynamic Text (varies based on a formula)',i:'carbon:text-footnote', a:0, f:RichTextPiece.addRichText(itemPath, organicChanges, currentList, refObject, userNos, userID, ownVariables, urlParamsForExecution, urlHeader, chains, width, height, onClickItemChangeSelection, setIsShowingSomeDropDown)}
      ]
}



export function duplicateItem(itemPath, currentList, organicChanges, userNos, setItemEdited, insetWidth, insetHeight, currentType, setIsShowingSomeDropDown){
  return function(e){
    var p1 = ResponsiveFns.stripOffLastItem(itemPath);
    var pathDown = p1.priors;
    var uuid = CoreFns.uuidScoped(userNos, currentList, pathDown, []);  
    var oldPiece = CoreFns.goDownPath(currentList, itemPath);
    var oldPieceClean = JSON.parse(JSON.stringify(oldPiece));
    var addChanges = CoreFns.replaceSpansInSomething(oldPieceClean, currentList, userNos);

    if (itemPath.length > 6 || CoreFns.isAlert(itemPath) || itemPath[2] === 'nv'){
      var ord = ResponsiveFns.getNextOrd(currentList, pathDown);
      oldPieceClean.s.ord = {t:'int',v:ord};    
    }else if (itemPath[4] === 'i'){
      var pos = oldPieceClean.pos;
      if (pos.l){
        pos.l.v = pos.l.v + EditorHelpers.scaledDistance(100, pos.l.t, 'l', insetWidth, insetHeight);
      }
      if (pos.t){
        pos.t.v =  pos.t.v + EditorHelpers.scaledDistance(100, pos.t.t, 't', insetWidth, insetHeight);
      }
      if (pos.b){
        pos.b.v =  pos.b.v - EditorHelpers.scaledDistance(100, pos.b.t, 'b', insetWidth, insetHeight);
      }
      if (pos.r){
        pos.r.v =  pos.r.v - EditorHelpers.scaledDistance(100, pos.r.t, 'r', insetWidth, insetHeight);
      }
    }
    var changes = [{t:'w',w:pathDown.concat([uuid]),n:oldPieceClean}].concat(addChanges);
    organicChanges(changes);
    var newPath = pathDown.concat([uuid]);
    setItemEdited({t:currentType, path:newPath});
    if (StyleFunctions.isFirstLevel(newPath) && newPath[4] === 'i' && pathDown.length === 6){
      setIsShowingSomeDropDown({t:'move'});
    }else{
      setIsShowingSomeDropDown({t:'itemPosition'});
    }
  }
}


export function toggleBIU(whichCharSet, newState, doInputActions, ref1, itemPath, toggle, setToggle, insetWidth, insetHeight){
    return function(e){

      var reference = whichCharSet.t;
      var newVal = whichCharSet.v;
      if (newState){
        newVal = false;
      }

      var sel = document.getSelection();
      var range = document.createRange();
      
      function addNode(text, attributes, location){
        if (text.length > 0){
          var beforeNode = document.createTextNode(text);
          var item = ResponsiveFns.coverNodeWithAttributes(beforeNode, attributes, insetWidth, insetHeight);
          location.parentNode.insertBefore(item, location);
          return beforeNode;
        }
      }

      function replaceTextOfNode(after7, nodeHere, nodeBeforeParent7){
        if (after7.length > 0){
          nodeHere.textContent = after7;
        }else{
          nodeBeforeParent7.parentNode.removeChild(nodeBeforeParent7);
        }
        
      }                   
      var nodeHere = sel.anchorNode;
      var inlines3 = getInlinesOfANode(sel.anchorNode, itemPath);

      if (sel.type === 'Caret'){
          var attribValueHere3 = ResponsiveFns.attribValue(inlines3, reference);
          if (attribValueHere3 === newVal){
            return;
          }else{
            if (nodeHere){
              if (nodeHere.tagName === 'DIV'){

                var currentNode1 = document.createTextNode(String.fromCharCode(8203));
                var sAttribs1 = ResponsiveFns.newAttrib(inlines3, reference, newVal);
                var item21 = ResponsiveFns.coverNodeWithAttributes(currentNode1, sAttribs1, insetWidth, insetHeight);
                if (sel.anchorOffset <= nodeHere.childNodes.length){
                  nodeHere.insertBefore(item21, nodeHere.childNodes[sel.anchorOffset]);
                }else{
                  nodeHere.appendChild(item21);
                }

                range.setStart(item21, 1);
                range.setEnd(item21, 1);
                range.collapse(true);
                sel.removeAllRanges()
                sel.addRange(range);
                setToggle(1 - toggle);

              }else{
                var nodeBeforeParent8 = escalateUpwardsToJustBeforeDiv(nodeHere);
                if (!nodeBeforeParent8){
                  return;
                }
                var textContent = nodeHere.textContent;
                var before3 = textContent.substr(0, sel.anchorOffset).split(String.fromCharCode(8203)).join('');
                var after3 = textContent.substr(sel.anchorOffset);

                addNode(before3, inlines3, nodeBeforeParent8);

                var currentNode = document.createTextNode(String.fromCharCode(8203));
                var sAttribs = ResponsiveFns.newAttrib(inlines3, reference, newVal);
                var item2 = ResponsiveFns.coverNodeWithAttributes(currentNode, sAttribs, insetWidth, insetHeight);
                nodeBeforeParent8.parentNode.insertBefore(item2, nodeBeforeParent8);

                replaceTextOfNode(after3, nodeHere, nodeBeforeParent8);
                range.setStart(item2, 1);
                range.setEnd(item2, 1);
                range.collapse(true);
                sel.removeAllRanges()
                sel.addRange(range);
                setToggle(1 - toggle);
    
              }
            }
          
        }

      }else if (sel.type === 'Range'){
        var attribValueHere = ResponsiveFns.attribValue(inlines3, reference);
        var sAttribs3 = ResponsiveFns.newAttrib(inlines3, reference, newVal);
        if (sel.anchorNode === sel.focusNode){
          if (attribValueHere === newVal){
            return;
          }else{
            if (nodeHere){
              var nodeBeforeParent7 = escalateUpwardsToJustBeforeDiv(nodeHere);
              if (!nodeBeforeParent7){
                return;
              }
              var leftOne = sel.anchorOffset;
              var rightOne = sel.focusOffset;
              if (leftOne > rightOne){
                rightOne = sel.anchorOffset;
                leftOne = sel.focusOffset;
              }
              var textContent7 = nodeHere.textContent;
              var before7 = textContent7.substr(0, leftOne);
              var inside = textContent7.substr(leftOne, rightOne - leftOne);
              var after7 = textContent7.substr(rightOne);
              addNode(before7, inlines3, nodeBeforeParent7);
              var ins = addNode(inside, sAttribs3, nodeBeforeParent7);
              replaceTextOfNode(after7, nodeHere, nodeBeforeParent7);
              if (ins){
                range.setStart(ins, 0);
                range.setEnd(ins, inside.length);
                sel.removeAllRanges()
                sel.addRange(range);
              }
              doInputActions(ref1);

            }
          }  
        }else{
          if (nodeHere){
            var backward = checkIfNodeBefore(sel);
            var leftNode; var rightNode; var leftOffset; var rightOffset;
            if (backward){
              leftNode = sel.focusNode;
              leftOffset = sel.focusOffset;
              rightNode = sel.anchorNode;
              rightOffset = sel.anchorOffset;
            }else{
              rightNode = sel.focusNode;
              rightOffset = sel.focusOffset;
              leftNode = sel.anchorNode;
              leftOffset = sel.anchorOffset;
            }

            var nodeBeforeParent = escalateUpwardsToJustBeforeDiv(leftNode);
            if (!nodeBeforeParent){
              return;
            }

            var textContent6 = leftNode.textContent;
            var before = textContent6.substr(0, leftOffset);
            var after = textContent6.substr(leftOffset);
            if (after.length > 0){
              addNode(before, inlines3, nodeBeforeParent);
            }

            function goRightAndCleanUntilFindEndNode(coveredNode){
              if (!coveredNode){
                return;
              }
              var nextNode = coveredNode.nextSibling;
              var parent = coveredNode.parentNode;
              if (nextNode){
                var siblingNos = -1;
                var parentChildren = parent.childNodes;
                for (var i = 0; i < parentChildren.length; i++){
                  if (parentChildren[i] === nextNode){
                    siblingNos = i;
                    break;
                  }
                }
                var isInside = seeIfEndNodeIsInside(nextNode);
                if (!isInside){
                  var thisNewNode = parentChildren[siblingNos];
                  goRightAndCleanUntilFindEndNode(thisNewNode);
                }
              }else{
                if (parent === rightNode){
                  return;
                }else{
                  goRightAndCleanUntilFindEndNode(parent);
                }
              }
            }

            function seeIfEndNodeIsInside(node){
              if (node === rightNode){
                return true;
              }else if (node.id){
                return false;
              }else if (!node.tagName){
                var inlinesX = getInlinesOfANode(node, itemPath);
                var sAttribsX = ResponsiveFns.newAttrib(inlinesX, reference, newVal);
                var nodeAtMid = escalateUpwardsToJustBeforeDiv(node);
                addNode(node.textContent, sAttribsX, nodeAtMid);
                nodeAtMid.parentNode.removeChild(nodeAtMid);
                return false;
              }else{
                var childNodes = node.childNodes;
                for (var i = 0; i < childNodes.length; i++){
                  var aChild = childNodes[i];
                  var p = seeIfEndNodeIsInside(aChild);
                  if (p){
                    return true;
                  }
                }
                return false;
              }
            }

            goRightAndCleanUntilFindEndNode(nodeBeforeParent);

            var startPiece = addNode(after, sAttribs3, nodeBeforeParent);
            nodeBeforeParent.parentNode.removeChild(nodeBeforeParent);

            var nodeAtEnd = escalateUpwardsToJustBeforeDiv(rightNode);
            if (!nodeAtEnd){
              return;
            }
            if (rightNode.tagName === 'DIV'){
              range.setEnd(rightNode, rightOffset);
            }else{
              var textContent2 = rightNode.textContent;
              var before1 = textContent2.substr(0, rightOffset);
              var after1 = textContent2.substr(rightOffset);
              var inlines4 = getInlinesOfANode(rightNode, itemPath);
              var sAttribs4 = ResponsiveFns.newAttrib(inlines4, reference, newVal);
              var endPiece = addNode(before1, sAttribs4, nodeAtEnd);
              replaceTextOfNode(after1, rightNode, nodeAtEnd);
              range.setEnd(endPiece, before1.length);
            }
            doInputActions(ref1);
            range.setStart(startPiece, 0);
            sel.removeAllRanges()
            sel.addRange(range);
          } 
        }


      }
    }
  }


export function checkIfNodeBefore(sel){
  if (sel.focusNode){
    var position = sel.anchorNode.compareDocumentPosition(sel.focusNode);
    if ((!position && sel.anchorOffset > sel.focusOffset) || (position === Node.DOCUMENT_POSITION_PRECEDING)){
      return true;         
    }
  }
  return false;
}

function escalateUpwardsToJustBeforeDiv(node){
  if (node){
    var parent = node.parentNode;
    if (ResponsiveFns.isDivOrTableCell(parent)){
      return node;
    }else{
      return escalateUpwardsToJustBeforeDiv(parent);
    }

  }
}

function checkActive(inlines5, v){
    for (var i = 0; i < inlines5.length; i++){
      if (inlines5[i].v === v){
        return true;
      }
    }
    return false;
  }

export function getInlinesOfANode(n, thisItemPath){

  function actuallyGetInline(node){
    if (!node){
      return [];
    }
    if (node.id === 'editor' + thisItemPath.join('_') || node.tagName === 'BODY' || node.tagName === 'SUMMARY' || node.tagName === 'DETAILS' || node.tagName === 'A' || node.tagName === 'UL'  || node.tagName === 'LABEL'){
      return [];
    }else{
      var toAdd = [];
      var tagName = node.tagName;
      if (!tagName){
      }else if (tagName === 'U' || tagName === 'B' || tagName === 'I'){
        toAdd = [{t:tagName,v:tagName}];
      }else if (tagName === 'SPAN'){
        // if (node.id){
        // }else{
          var style = node.style;
          for (var i = 0; i < 10; i++){
            var iText = i.toString();
            if (style[iText]){
              if (style[iText] === 'color' || style[iText] === 'caret-color'){
                toAdd.push({t:'C',v:style.color});
              }else if (style[iText] === 'background-color'){
                toAdd.push({t:'D',v:style['background-color']});
              }else if (style[iText] === 'font-size' || style[iText] === 'fontSizeP'){
                if (style.fontSizeP){
                  toAdd.push({t:'F',v:style.fontSizeP});
                }else{
                  toAdd.push({t:'F',v:style.fontSize});
                }
              }else if (style[iText] === 'font-family'){
                toAdd.push({t:'G',v:style['font-family']});
              // }else if (style[iText] === 'caret-color'){
              //   toAdd.push({t:'C',v:style['color']});
              }else if (style[iText] === 'cursor' || style[iText] === 'padding-left' || style[iText] === '-webkit-text-fill-color'){
              }else if (style[iText] === 'background-image'){
                toAdd.push({t:'C', v:style['background-image']});
              }else if (style[iText]){
                console.warn(style[iText]);
              }
            }else{
              break;
            }
          }
      }else if (tagName === 'FONT'){
        if (node.face){
          toAdd.push({t:'G',v:node.face})
        }
        if (node.backgroundColor){
          toAdd.push({t:'D',v:node.backgroundColor})
        }
        if (node.color){
          toAdd.push({t:'C',v:node.color});
        }
        return toAdd;
      }else if (tagName === 'DIV' || tagName === 'TABLE' || tagName === 'TBODY' || tagName === 'TR' || tagName === 'TD'  || tagName === 'CENTER' || tagName === 'NAV' || tagName === 'P' || tagName === 'BUTTON' || tagName === 'BR'|| tagName === 'LI'){
      }else{
        console.warn(tagName);
      }
      return toAdd.concat(actuallyGetInline(node.parentNode));
    }     
  }
  return actuallyGetInline(n);
}

export function doAddChanges(currentList, objPath, newObjPathX, chains, changeTab){
  var addChanges = [];
    var smartContractsTouched = ActionModifiers.findIssues(currentList, false, 'scUsage', chains, changeTab);
    smartContractsTouched.forEach((aChange, index)=>{
      var origPath = [];
      if (aChange.n === 'changeInputValue' || aChange.n === 'inP' || aChange.n === 'gV' || aChange.n === 'formulaINP' || aChange.n === 'formulaGV'){
        if (aChange.n === 'changeInputValue'){
          origPath = aChange.t.t.substr(16).split(' ');
        }else if (aChange.n === 'inP' || aChange.n === 'gV' || aChange.n === 'formulaINP' || aChange.n === 'formulaGV'){
          origPath = aChange.t.v;
        }
        var isMatch = checkPathMatchAndDeliverNewPathIfSo(objPath, newObjPathX, origPath);
        if (isMatch){
          var newObjPath = isMatch;
          if (aChange.n === 'changeInputValue'){
            aChange.t.t = 'changeInputValue' + newObjPath.join(' ');
            var newP = checkPathMatchAndDeliverNewPathIfSo(objPath, newObjPathX, aChange.path);
            if (!newP){
              newP = aChange.path;
            }
            addChanges.push({t:'w',w:newP,n:aChange.t});
          }else if (aChange.n === 'inP' || aChange.n === 'gV' || aChange.n === 'formulaINP' || aChange.n === 'formulaGV'){
            aChange.t.v = newObjPath;
            if (aChange.n === 'inP' || aChange.n === 'gV'){//this means its formulaO that's changed.
              var pathToCheck = aChange.path.concat(['o']);
              var origFormulaO = CoreFns.goDownPath(currentList, pathToCheck);
              var newP1 = checkPathMatchAndDeliverNewPathIfSo(objPath, newObjPathX, pathToCheck);
              if (!newP1){
                newP1 = pathToCheck;
              }
              addChanges.push({t:'w', w:newP1, n:origFormulaO});
            }else{

              var pathToCheck2 = aChange.path.concat(aChange.loc);
              var newP2 = checkPathMatchAndDeliverNewPathIfSo(objPath, newObjPathX, pathToCheck2);
              if (!newP2){
                newP2 = pathToCheck2;
              }
              var origFormulaXOrY = CoreFns.goDownPath(currentList, pathToCheck2);
              addChanges.push({t:'w', w:newP2, n:origFormulaXOrY});

            }
          }
        }
      }

    })
    return addChanges;

}
function checkPathMatchAndDeliverNewPathIfSo(referencePath, newReferencePath, comparisonPath){
    var isMatch = true;
    for (var i = 0; i < referencePath.length; i++){
      if (referencePath[i] === comparisonPath[i]){
      }else{
        isMatch = false;
        break;
      }
    }
    if (isMatch){
      var newObjPath = [...newReferencePath];
      for (var i1 = referencePath.length; i1 < comparisonPath.length; i1++){
        newObjPath.push(comparisonPath[i1]);
      }
      return newObjPath;
    }
    return false;
}


  function modifyPieceAndAddNewSpans(oldPieceClean, currentList, userNos){
    var checkNav = CoreFns.replaceSpansInSomething(oldPieceClean.nv, currentList, userNos);
    var screens = oldPieceClean._s;
    var screenKeys = Object.keys(screens);
    screenKeys.forEach((aScreenKey, index)=>{
      var toCheck = CoreFns.replaceSpansInSomething(screens[aScreenKey], currentList, userNos);
      checkNav = checkNav.concat(toCheck);
    })
    return checkNav;
  }

